import React, { useState, useEffect, useMemo, useCallback } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import DataTable from "react-data-table-component";

// API
import ItemService from "../../../../services/customer_appCommonService";
import {
  //eslint-disable-next-line
  clearEquipmentRentNumbers,
  getEquipmentRentFormDetail,
  setEquipmentRentDocumentNumber,
} from "../../../../redux/feature/customer_app/customerSlice";

// Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import Loader from "../../../../Components/Loader";
import MaterialSelectionModalV5 from "./MaterialSearchModal";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import Constants from "../../../../common/CustomerConstants";
import BarcodeSelectorMRCustomerV5 from "./BarcodeSelectorMRCustomerV5";
// Validations
import {
  getTodaysData,
  validateRequired,
  validateContactNumber,
} from "../../../../common/Validations";

// Constants & Utils
import {
  ERF_TYPES,
  PRIVILEGE_SETTINGS,
  DEFAULT_PRIVILEGE_SETTINGS,
  PAYMENT_MODES,
  PAYMENT_MODE_RULES,
} from "./ERFConfigFileConstant";

import {
  SALE_POINT_OPTIONS,
  APPROVED_BY_OPTIONS_LEVEL_ONE,
  APPROVED_BY_OPTIONS_LEVEL_TWO,
  ORDER_TYPE_OPTIONS,
  SOURCE_OF_CALL_OPTIONS,
  ID_PROOF_OPTIONS,
  DOCTOR_TYPE_OPTIONS,
  // HOSPITAL_OPTIONS,
  STATE_OPTIONS,
  IS_DIABETIC_OPTIONS,
  // MOCK_DOCTORS,
} from "./constants";

import { message, calculateDays, calculateEndDate } from "./utils";
import UpdateRemarksModal from "../Common/UpdateRemarksModal";
// import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import ErfExtenssionModal from "./ErfExtenssionModal";
import ERFAutocompleteSearch from "./ERFAutocompleteSearch";
import CustomerConstants from "../../../../common/CustomerConstants";
import ERFPaymentHistoryView from "./ERFPaymentHistoryView";

const ERFDetailSummary = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Redux Data
  const userData = useSelector((state) => state?.user?.data);
  // console.log("userData", userData);
  const currentUserId = userData.userId || "M000";
  const documentNumber = useSelector(
    (state) => state?.customer?.equipmentRentForm?.documentNumber,
  );

  // console.log("documentNumber", documentNumber)

  const equipmentNr = useSelector(
    (state) => state?.customer?.equipmentRentExtForm?.documentNumber,
  );
  // console.log("equipmentNr", equipmentNr);

  // eslint-disable-next-line
  const isStoreUser = userData?.category?.toUpperCase() === "STORE";

  const getErfTypeByName = (name) => {
    return ERF_TYPES.find((type) => type.name === name);
  };

  const convertToNumbers = (obj) => {
    const converted = { ...obj };

    const numericFields = [
      "orderedQuantity",
      "sellingPrice",
      "rentPerDay",
      "rent7Days",
      "rent15Days",
      "rent30Days",
      "days",
      "netValue",
      "grossValue",
      "taxPercentage",
      "taxAmount",
      "actualSecurityAmt",
      "securityAmt",
      "masterMRP",
      "masterSellingPrice",
      "masterUnitPrice",
      "refundAmt",
      "refundDays",
    ];

    numericFields.forEach((field) => {
      if (converted[field] !== undefined && converted[field] !== "") {
        converted[field] = parseFloat(converted[field]) || 0;
      }
    });

    return converted;
  };

  // UI State
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line
  const [edit, setEdit] = useState(true); // true = View Mode, false = Edit Mode
  const [disabled, setDisabled] = useState(true); // Controls input fields
  const [isFormEnabled, setIsFormEnabled] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  const [activeItemType, setActiveItemType] = useState("Rent");

  const [barcodeOptionsMap, setBarcodeOptionsMap] = useState({});
  const [assigningBarcode, setAssigningBarcode] = useState({});

  // Accordion Toggles
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [visible, setVisible] = useState({
    PAY: true,
    SEC: true,
    SMOD: true,
  });

  // Modal State
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);
  const [failureModalData] = useState({
    title: "Validation Error",
    ErrorMsg: "Please check the required fields.",
  });

  // Data State
  const [hospitalList, setHospitalList] = useState([]); // Dynamic Hospital List
  const [rentItems, setRentItems] = useState([]);
  const [saleItems, setSaleItems] = useState([]); // reused for Service Items
  const [validation, setValidation] = useState({});

  const [doctorsList, setDoctorsList] = useState([]);
  const [isLoadingHospitals, setIsLoadingHospitals] = useState(false);
  const [isLoadingDoctors, setIsLoadingDoctors] = useState(false);

  const [selectedERF, setSelectedERF] = useState(null);
  const [isERFLoaded, setIsERFLoaded] = useState(false);

  const [erfForType, setErfForType] = useState("Patient"); // "Patient" or "Hospital"
  const [selectedHospital, setSelectedHospital] = useState(null);
  const [erfHospitalList, setErfHospitalList] = useState([]);
  const [isErfLoadingHospitals, setErfIsLoadingHospitals] = useState(false);

  // ----------Approval Process-----------------
  const APPROVAL_REQUIRED_CASES = [
    "SPECIAL CASE",
    "DISCOUNT",
    "SPECIAL CASE+DISCOUNT",
  ];

  // Main Form Data
  const [formInputs, setFormInputs] = useState({
    // Order Details
    erfType: "Select",
    erfTypeCode: "",
    erfTypeDescription: "",
    orderDate: "",
    salePoint: userData?.organisationName || "",
    costCenter: userData?.firstName || "",
    privilegeCase: "Select",
    approvedBy: "Mr. Kishore Sharma",
    billingName: "Patient",
    orderType: "Select",
    sourceOfCall: "Select",

    // Doctor Details
    doctorName: "",
    drType: "Select",
    drCode: "",
    hospital: "",

    // Patient Details
    patientName: "",
    contactNumber: "",
    age: "",
    weight: "",
    gender: "",
    gstNo: "",
    panNo: "",
    isDiabetic: "No",
    aadharNo: "",
    patientChallenges: "",

    // Caregiver Details
    caregiverName: "",
    caregiverRelation: "",
    idProof: "Select",
    idProofNumber: "",
    emailId: "",

    // Address
    billingAddress: "",
    billingState: "Select",
    billingPinCode: "",
    deliveryAddress: "",
    deliveryState: "Select",
    deliveryPinCode: "",

    // Payment Details (Left)
    cartage: "",
    installationCharges: "",
    receivedAmount: "",

    // Payment Breakup (Right)
    paymentMode: "Select",
    cashAmount: "",
    balanceAmtBreakup: "0",
    chequeNo: "",
    cardTransNo: "",
    bankName: "",
    receiptNo: "",

    // Security Details (Left)
    standardSecurityAmt: 0,
    receivedSecurityAmt: "",

    // Security Breakup (Right)
    securityPincode: "",
    securityAmtMode: "Select",
    securityCashAmt: "",
    balanceSecurityBreakup: "0",
    securityChequeNo: "",
    securityCardTransNo: "",
    securityBankName: "",

    // Security Mode
    securityMode: "Select",
    securityModeCash: "",
    securityModeBal: "0",
    remarks: "",

    // Approval process
    approvalLevel: "", // Stores "1" or "2"
    approvers: [],
  });

  const erfTypeOptions = useMemo(() => ERF_TYPES, []);

  const paymentModeDropdown = useMemo(
    () =>
      Object.values(PAYMENT_MODES).map((mode, i) => ({
        id: i + 1,
        name: mode,
      })),
    [],
  );

  const privilegeOptions = useMemo(() => {
    // Find the ERF object that matches the selected name
    const selectedType = ERF_TYPES.find(
      (type) => type.name === formInputs.erfType,
    );

    // Return its embedded privileges, or empty array if not found
    return selectedType?.privileges || [];
  }, [formInputs.erfType]);

  // Calculate Totals
  const allItems = useMemo(
    () => [...rentItems, ...saleItems],
    [rentItems, saleItems],
  );

  const totals = useMemo(() => {
    return allItems.reduce(
      (acc, item) => {
        acc.net += parseFloat(item.netValue || 0);
        acc.tax += parseFloat(item.taxAmount || 0);
        if (item.itemType === "Rent") {
          acc.security += parseFloat(item.securityAmt || 0);
        }
        return acc;
      },
      { net: 0, tax: 0, security: 0 },
    );
  }, [allItems]);

  const calculateRentTotals = (item) => {
    const qty = parseFloat(item.orderedQuantity) || 0;
    const days = parseFloat(item.days) || 0;
    const tax = parseFloat(item.taxPercentage) || 0;
    const rentSlab = item.rentSlab || "Per Day";

    let effectiveRentPrice = 0;

    switch (rentSlab) {
      case "Per Day":
        effectiveRentPrice = (parseFloat(item.rentPerDay) || 0) * days;
        break;
      case "7 Days":
        effectiveRentPrice = parseFloat(item.rent7Days) || 0;
        break;
      case "15 Days":
        effectiveRentPrice = parseFloat(item.rent15Days) || 0;
        break;
      case "30 Days":
        effectiveRentPrice = parseFloat(item.rent30Days) || 0;
        break;
      default:
        effectiveRentPrice = (parseFloat(item.rentPerDay) || 0) * days;
    }

    const netVal = qty * effectiveRentPrice;
    const taxAmt = netVal * (tax / 100);
    const grossVal = netVal + taxAmt;

    let sellingPrice = 0;
    if (rentSlab === "Per Day") {
      sellingPrice = parseFloat(item.rentPerDay) || 0;
    } else {
      sellingPrice = days > 0 ? effectiveRentPrice / days : 0;
    }

    return {
      netValue: parseFloat(netVal.toFixed(2)),
      taxAmount: parseFloat(taxAmt.toFixed(2)),
      grossValue: parseFloat(grossVal.toFixed(2)),
      sellingPrice: parseFloat(sellingPrice.toFixed(2)),
    };
  };

  const totalPayable = (totals.net + totals.tax).toFixed(2);

  const netAmount = (
    parseFloat(totalPayable) +
    (parseFloat(formInputs.cartage) || 0) +
    (parseFloat(formInputs.installationCharges) || 0)
  ).toFixed(2);

  const balanceAmount = (
    parseFloat(netAmount) - (parseFloat(formInputs.receivedAmount) || 0)
  ).toFixed(2);

  const balanceSecurityAmt = (
    totals.security - (parseFloat(formInputs.receivedSecurityAmt) || 0)
  ).toFixed(2);

  // =============================================================================
  // EFFECTS
  // =============================================================================

  // // 1. Load Initial Data
  // const loadInitialPageData = useCallback(async () => {
  //   if (documentNumber) {
  //     setLoading(true);
  //     try {
  //       const payload = {
  //         queryName: "ERFDetail",
  //         page: 1,
  //         per_page: 1,
  //         timeZone: "Asia/Calcutta",
  //         documentNumber: documentNumber,
  //       };
  //       const resultAction = await dispatch(
  //         getEquipmentRentFormDetail(payload),
  //       );
  //       if (getEquipmentRentFormDetail.fulfilled.match(resultAction)) {
  //         const data = resultAction.payload.data?.[0];
  //         if (data) {
  //           setFormInputs((prev) => ({ ...prev, ...data }));

  //           if (data.rentItems && data.rentItems.length > 0) {
  //             setRentItems(data.rentItems);
  //           }
  //           if (data.saleItems && data.saleItems.length > 0) {
  //             setSaleItems(data.saleItems);
  //           } else if (
  //             data.serviceItems &&
  //             data.serviceItems.length > 0 &&
  //             data.erfType === "Service"
  //           ) {
  //             setSaleItems(data.serviceItems);
  //           } else if (data.items) {
  //             setRentItems(data.items.filter((i) => i.itemType === "Rent"));
  //             setSaleItems(data.items.filter((i) => i.itemType !== "Rent"));
  //           }
  //         }
  //       } else {
  //         toast.error("Failed to fetch ERF details");
  //       }
  //     } catch (err) {
  //       console.error("Load Error:", err);
  //       toast.error("Error loading ERF details");
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  // }, [documentNumber, dispatch]); // ← Add dependencies array

  const loadInitialPageData = useCallback(async () => {
    if (documentNumber) {
      // setLoading(true);
      try {
        const payload = {
          queryName: "ERFDetail",
          page: 1,
          per_page: 1,
          timeZone: "Asia/Calcutta",
          documentNumber: documentNumber,
        };
        const resultAction = await dispatch(
          getEquipmentRentFormDetail(payload),
        );
        if (getEquipmentRentFormDetail.fulfilled.match(resultAction)) {
          const data = resultAction.payload.data?.[0];
          if (data) {
            setFormInputs((prev) => ({ ...prev, ...data }));

            if (data.rentItems && data.rentItems.length > 0) {
              setRentItems(data.rentItems);
            }
            if (data.saleItems && data.saleItems.length > 0) {
              setSaleItems(data.saleItems);
            } else if (
              data.serviceItems &&
              data.serviceItems.length > 0 &&
              data.erfType === "Service"
            ) {
              setSaleItems(data.serviceItems);
            } else if (data.items) {
              setRentItems(data.items.filter((i) => i.itemType === "Rent"));
              setSaleItems(data.items.filter((i) => i.itemType !== "Rent"));
            }

            // Also restore erfForType from loaded data
            if (data.erfForType) {
              setErfForType(data.erfForType); // "Patient" or "Hospital"
            }

            // Restore selected hospital if hospital ERF
            if (data.erfForType === "Hospital" && data.hospitalName) {
              setSelectedHospital({
                hospitalName: data.hospitalName,
                AssociateNumber: data.AssociateNumber,
                mobileNr: data.mobileNr,
                email: data.email,
              });
            }
          }
        } else {
          toast.error("Failed to fetch ERF details");
        }
      } catch (err) {
        console.error("Load Error:", err);
        toast.error("Error loading ERF details");
      } finally {
        setLoading(false);
      }
    }
  }, [documentNumber, dispatch]); // ← Add dependencies array

  useEffect(() => {
    loadInitialPageData();
    // eslint-disable-next-line
  }, [documentNumber]);

  const loadInitialPageDataHistory = async () => {
    const docNumberToUse = documentNumber || equipmentNr;
    if (!docNumberToUse) return;

    setLoading(true);
    try {
      const payload = {
        queryName: "ERFExtDetail",
        documentNumber: docNumberToUse,
      };
      const resultAction = await dispatch(getEquipmentRentFormDetail(payload));

      if (getEquipmentRentFormDetail.fulfilled.match(resultAction)) {
        const data = resultAction.payload.data?.[0];
        if (data) {
          setFormInputs((prev) => ({ ...prev, ...data }));

          if (data.rentItems?.length > 0) {
            const mappedRentItems = data.rentItems.map((item) => ({
              ...item,
              version: "E0",
            }));
            setRentItems(mappedRentItems);
          } else {
            setRentItems([]);
          }

          const extensionList = [];

          const currentExNr = data.documentNumber; // "EX0043"
          const currentExNum = parseInt(currentExNr.replace("EX", ""), 10); // 43

          data.rentItems?.forEach((item) => {
            const totalVersions = item.extensionHistory?.length || 0; // 4
            const baseExNum = currentExNum - (totalVersions - 1); // 43 - 3 = 40

            item.extensionHistory?.forEach((ext, index) => {
              const exNum = baseExNum + index; // 40, 41, 42, 43
              const paddedExNum = String(exNum).padStart(4, "0"); // "0040"
              const mappedExNr = `EX${paddedExNum}`; // "EX0040"

              extensionList.push({
                ...ext,
                materialCode: item.materialCode,
                materialDescription: item.materialDescription,
                equipmentItemNr: item.equipmentItemNr,
                barcode: item.barcode,
                equipmentRentNr: mappedExNr,
                documentNumber: mappedExNr,
              });
            });
          });
          extensionList.sort((a, b) => {
            const versionA = parseInt(a.version.replace("E", ""), 10);
            const versionB = parseInt(b.version.replace("E", ""), 10);
            return versionB - versionA;
          });

          // console.log("extensionList:", extensionList);
          setExtensionData(extensionList);
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error loading ERF details");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (documentNumber || equipmentNr) {
      loadInitialPageDataHistory();
    }
    // eslint-disable-next-line
  }, [documentNumber, equipmentNr]);

  // Enable/Disable Form
  useEffect(() => {
    const isEnabled =
      formInputs.erfType !== "Select" && formInputs.privilegeCase !== "Select";
    setIsFormEnabled(isEnabled);
  }, [formInputs.erfType, formInputs.privilegeCase]);

  // Handle Dropdown Selections
  useEffect(() => {
    if (getDropdownData) {
      const { textField, name } = getDropdownData;

      setFormInputs((prev) => {
        const newData = { ...prev, [textField]: name };

        if (textField === "erfType") {
          const selectedErfType = getErfTypeByName(name);
          if (selectedErfType) {
            newData.erfTypeCode = selectedErfType.code;
            newData.erfTypeDescription = selectedErfType.description;
          }
          newData.privilegeCase = "Select";
        }

        // if (textField === "drType") {
        //   newData.hospital = "";
        //   newData.doctorName = "";
        //   newData.drCode = "";
        //   setAvailableDoctors([]);

        //   //  Call API when "Listed" is selected
        //   if (name === "Listed") {
        //     fetchHospitalList();
        //   }
        // }

        // //  Hospital selection WITH API CALL
        // if (textField === "hospital") {
        //   newData.doctorName = "";
        //   newData.drCode = "";

        //   //  Call API to fetch doctors for this hospital
        //   if (name) {
        //     fetchDoctorsByHospital(name);
        //   }
        // }

        // //  Doctor Name selection with auto-fill
        // if (textField === "doctorName") {
        //   // Find the selected doctor object from our API state
        //   const selectedDoc = availableDoctors.find((doc) => doc.name === name);

        //   if (selectedDoc) {
        //     newData.drCode = selectedDoc.drCode || ""; // Auto-fill code
        //   }
        // }

        // Reset Doctor Logic
        if (textField === "drType") {
          newData.hospital = "";
          newData.doctorName = "";
          newData.drCode = "";
          setHospitalList([]);
          setDoctorsList([]);

          if (name === "Hospital") {
            // User selected "Hospital" → Fetch hospital list
            fetchHospitalList();
          } else if (name === "Doctor") {
            // User selected "Doctor" → Fetch all doctors directly
            fetchAllDoctors();
          } else if (name === "Listed") {
            // Keep existing "Listed" logic if needed
            fetchHospitalList(); // Or keep your old logic
          }
        }

        if (textField === "hospital") {
          newData.doctorName = "";
          newData.drCode = "";

          if (name) {
            // Fetch doctors for this hospital
            fetchDoctorsByHospital(name);
          }
        }

        if (textField === "doctorName") {
          // Find the selected doctor from doctorsList
          const selectedDoc = doctorsList.find((doc) => doc.name === name);

          if (selectedDoc) {
            // Auto-fill doctor details
            newData.drCode = selectedDoc.userId || selectedDoc.code || "";

            // Optional: Auto-fill hospital if not already selected
            if (!newData.hospital && selectedDoc.hospitalName) {
              newData.hospital = selectedDoc.hospitalName;
            }
          }
        }

        // Reset ERF Type / Privilege
        if (textField === "erfType" || textField === "privilegeCase") {
          // Only reset items if explicit change by user, not initial load
          // But here we rely on standard CreateERF behavior.
          // Note: On initial load, this might trigger if we're not careful.
          // However, useEffect runs after render. If data is loaded, states are set.
          // We need to avoid resetting if data just loaded.
          // But given the code structure, getDropdownData is set by ComboboxField callback.
          // So it only triggers on user interaction.

          setRentItems([]);
          setSaleItems([]);
          newData.cartage = "";
          newData.installationCharges = "";
          newData.receivedAmount = "";
          newData.paymentMode = "Select";
          newData.cashAmount = "";
          newData.balanceAmtBreakup = "0";
          newData.chequeNo = "";
          newData.cardTransNo = "";
          newData.bankName = "";
          newData.receiptNo = "";
          newData.receivedSecurityAmt = "";
          newData.securityPincode = "";
          newData.securityAmtMode = "Select";
          newData.securityCashAmt = "";
          newData.balanceSecurityBreakup = "0";
          newData.securityChequeNo = "";
          newData.securityCardTransNo = "";
          newData.securityBankName = "";
          newData.securityMode = "Select";
          newData.securityModeCash = "";
          newData.securityModeBal = "0";

          if (textField === "erfType" && prev.erfType !== name) {
            newData.privilegeCase = "Select";
          }
        }

        // Reset Payment Mode Logic
        if (textField === "paymentMode") {
          newData.cashAmount = "";
          newData.balanceAmtBreakup = "0";
          newData.chequeNo = "";
          newData.cardTransNo = "";
          newData.bankName = "";
          newData.receiptNo = "";
        }

        // Reset Security Amt Mode Logic
        if (textField === "securityAmtMode") {
          newData.securityCashAmt = "";
          newData.balanceSecurityBreakup = "0";
          newData.securityChequeNo = "";
          newData.securityCardTransNo = "";
          newData.securityBankName = "";
        }

        // Reset Security Mode Logic
        if (textField === "securityMode") {
          newData.securityModeCash = "";
          newData.securityModeBal = "0";
        }

        // Reset ID Proof
        if (textField === "idProof") {
          newData.idProofNumber = "";
        }

        return newData;
      });
    }
    // eslint-disable-next-line
  }, [getDropdownData]);

  // Filter Doctors
  // useEffect(() => {
  //   if (formInputs.drType === "Listed" && formInputs.hospital) {
  //     const docs = MOCK_DOCTORS.filter(
  //       (d) => d.hospital === formInputs.hospital,
  //     );
  //     setAvailableDoctors(
  //       docs.map((d, i) => ({ id: i + 1, name: d.name, ...d })),
  //     );
  //   } else {
  //     setAvailableDoctors([]);
  //   }
  // }, [formInputs.drType, formInputs.hospital]);

  // // Auto-fill Dr Code
  // useEffect(() => {
  //   if (formInputs.drType === "Listed" && formInputs.doctorName) {
  //     const doc = MOCK_DOCTORS.find(
  //       (d) =>
  //         d.name === formInputs.doctorName &&
  //         d.hospital === formInputs.hospital,
  //     );
  //     if (doc) {
  //       setFormInputs((prev) => ({ ...prev, drCode: doc.code }));
  //     }
  //   }
  // }, [formInputs.doctorName, formInputs.drType, formInputs.hospital]);

  // Update Dynamic Balances
  useEffect(() => {
    const receivedAmount = parseFloat(formInputs.receivedAmount) || 0;
    const cashAmount = parseFloat(formInputs.cashAmount) || 0;
    const balanceAmtBreakup = (receivedAmount - cashAmount).toFixed(2);

    const receivedSecurityAmt = parseFloat(formInputs.receivedSecurityAmt) || 0;
    const securityCashAmt = parseFloat(formInputs.securityCashAmt) || 0;
    const balanceSecurityBreakup = (
      receivedSecurityAmt - securityCashAmt
    ).toFixed(2);

    const securityModeCash = parseFloat(formInputs.securityModeCash) || 0;
    const securityModeBal = (
      parseFloat(balanceSecurityAmt) - securityModeCash
    ).toFixed(2);

    setFormInputs((prev) => ({
      ...prev,
      balanceAmtBreakup,
      balanceSecurityBreakup,
      securityModeBal,
    }));
  }, [
    formInputs.receivedAmount,
    formInputs.cashAmount,
    formInputs.receivedSecurityAmt,
    formInputs.securityCashAmt,
    balanceSecurityAmt,
    formInputs.securityModeCash,
  ]);

  // Auto-fill Cash Amt for Security Mode
  useEffect(() => {
    if (!formInputs.securityMode || formInputs.securityMode === "Select")
      return;

    const balSec = parseFloat(balanceSecurityAmt) || 0;

    if (["Cash", "Euro", "Dollar"].includes(formInputs.securityMode)) {
      setFormInputs((prev) => ({
        ...prev,
        securityModeCash: balSec.toString(),
        securityModeBal: "0",
      }));
    } else if (
      ["Card", "Cheque", "Online", "Paytm", "UPI", "Card&Cheque"].includes(
        formInputs.securityMode,
      )
    ) {
      setFormInputs((prev) => ({
        ...prev,
        securityModeCash: "0",
        securityModeBal: balSec.toString(),
      }));
    } else if (["Card&Cash", "Cheque&Cash"].includes(formInputs.securityMode)) {
      setFormInputs((prev) => ({
        ...prev,
        securityModeCash: "",
        securityModeBal: balSec.toString(),
      }));
    }
  }, [formInputs.securityMode, balanceSecurityAmt]);

  // =============================================================================
  // EVENT HANDLERS
  // =============================================================================

  const toggleCardVisibility = () => setCardVisible(!isCardVisible);
  const toggleCardVisibility2 = () => setCardVisible2(!isCardVisible2);
  const toggleCardVisibility3 = () => setCardVisible3(!isCardVisible3);
  const toggleCardVisibility5 = () => setCardVisible5(!isCardVisible5);
  const toggleCardVisibility4 = () => setCardVisible4(!isCardVisible4);
  const toggleVisibility = (key) =>
    setVisible((prev) => ({ ...prev, [key]: !prev[key] }));

  // Edit/View Handlers
  // eslint-disable-next-line
  const handleEdit = () => {
    setEdit(false);
    setDisabled(false);
  };
  // eslint-disable-next-line
  const handleCancelEdit = () => {
    setEdit(true);
    setDisabled(true);
    loadInitialPageData(); // Revert changes
  };

  const handleInputChange = ({ target: { name, value } }) => {
    const errors = {};
    const numericFields = [
      "cartage",
      "installationCharges",
      "receivedAmount",
      "cashAmount",
      "receivedSecurityAmt",
      "securityCashAmt",
      "securityModeCash",
      "age",
      "weight",
    ];

    if (numericFields.includes(name) && parseFloat(value) < 0) {
      toast.error(`${name} cannot be negative`);
      return;
    }

    setFormInputs((prev) => ({ ...prev, [name]: value }));

    if (name === "contactNumber") {
      !validateContactNumber(value)
        ? (errors.contactNumber = message.VALID_CONTACT_NUMBER)
        : (errors.contactNumber = "");
    }
    setValidation((prev) => ({ ...prev, [name]: errors[name] || "" }));
  };

  const handleERFSelection = (erfData) => {
    // console.log("Selected ERF:", erfData);

    setSelectedERF(erfData);
    setIsERFLoaded(true);

    // Auto-fill all patient details
    setFormInputs((prev) => ({
      ...prev,

      // Patient Details
      patientName: erfData.patientName || "",
      contactNumber: erfData.contactNumber || "",
      age: erfData.age || "",
      weight: erfData.weight || "",
      gender: erfData.gender || "",
      gstNo: erfData.gstNo || "",
      panNo: erfData.panNo || "",
      isDiabetic: erfData.isDiabetic || "No",
      aadharNo: erfData.aadharNo || "",
      patientChallenges: erfData.patientChallenges || "",

      // Caregiver Details
      caregiverName: erfData.caregiverName || "",
      caregiverRelation: erfData.caregiverRelation || "",
      idProof: erfData.idProof || "Select",
      idProofNumber: erfData.idProofNumber || "",
      emailId: erfData.emailId || "",

      // Billing Address
      billingAddress: erfData.billingAddress || "",
      billingState: erfData.billingState || "Select",
      billingPinCode: erfData.billingPinCode || "",

      // Delivery Address
      deliveryAddress: erfData.deliveryAddress || "",
      deliveryState: erfData.deliveryState || "Select",
      deliveryPinCode: erfData.deliveryPinCode || "",

      // Doctor Details (optional)
      doctorName: erfData.doctorName || "",
      drType: erfData.drType || "Select",
      drCode: erfData.drCode || "",
      hospital: erfData.hospital || "",
    }));

    // Clear validation errors
    setValidation({});

    // Show success message
    toast.success(`Patient details loaded from ERF ${erfData.documentNumber}`, {
      duration: 3000,
      icon: "✅",
    });
  };

  const fetchBarcodesForMaterial = useCallback(
    async (materialCode) => {
      if (barcodeOptionsMap[materialCode]) return;

      try {
        const payload = {
          queryName: "Get_Barcodes_By_MaterialCode",
          materialCode: materialCode,
        };

        const response = await ItemService.generateQuery(payload);

        if (response?.status === 200 && Array.isArray(response.data)) {
          setBarcodeOptionsMap((prev) => ({
            ...prev,
            [materialCode]: response.data.map((item, idx) => ({
              id: idx + 1,
              name: item.barcode || item.id || item.name,
              ...item,
            })),
          }));
        } else {
          toast.info(`No barcodes available for ${materialCode}`);
        }
      } catch (err) {
        console.error("Error fetching barcodes:", err);
        toast.error("Failed to load barcodes");
      }
    },
    [barcodeOptionsMap],
  );

  const handleBarcodeAssignment = useCallback(
    async (lineItemId, barcode, equipmentItemNr) => {
      if (!barcode) {
        toast.error("Please select a barcode first");
        return;
      }

      const allItems = [...rentItems, ...saleItems];
      const item = allItems.find((i) => i.local_id === lineItemId);

      if (!item) {
        toast.error("Item not found");
        return;
      }

      if (item.barcode === barcode) {
        toast.info("This barcode is already assigned to this item");
        return;
      }

      setAssigningBarcode((prev) => ({ ...prev, [lineItemId]: true }));

      try {
        const payload = {
          equipmentRentNr: documentNumber,
          erfTypeCode: formInputs.erfTypeCode,
          materialCode: item.materialCode,
          barcode: barcode,
          equipmentItemNr: equipmentItemNr,
        };

        const response =
          await ItemService.assignBarcodeForEquipmentRentForm(payload);

        if (response?.status === 200) {
          toast.success(`Barcode ${barcode} assigned successfully!`);

          await loadInitialPageData();
        } else {
          toast.error(response?.message || "Failed to assign barcode");
        }
      } catch (err) {
        console.error("Error assigning barcode:", err);
        toast.error(err?.response?.data?.message || "Failed to assign barcode");
      } finally {
        setAssigningBarcode((prev) => ({ ...prev, [lineItemId]: false }));
      }
    },
    [
      documentNumber,
      formInputs.erfTypeCode,
      rentItems,
      saleItems,
      loadInitialPageData,
    ],
  );

  const handleBarcodeRemoval = useCallback(
    async (lineItemId, barcode, equipmentItemNr) => {
      if (!barcode) {
        toast.error("No barcode to remove");
        return;
      }

      const allItems = [...rentItems, ...saleItems];
      const item = allItems.find((i) => i.local_id === lineItemId);

      if (!item) {
        toast.error("Item not found");
        return;
      }

      const confirmed = window.confirm(
        `Are you sure you want to remove barcode "${barcode}" from this item?`,
      );

      if (!confirmed) return;

      setAssigningBarcode((prev) => ({ ...prev, [lineItemId]: true }));

      try {
        const payload = {
          equipmentRentNr: documentNumber,
          erfTypeCode: formInputs.erfTypeCode,
          materialCode: item.materialCode,
          barcode: barcode,
          equipmentItemNr: equipmentItemNr,
        };

        const response =
          await ItemService.removeBarcodeForEquipmentRentForm(payload);

        if (response?.status === 200) {
          toast.success(`Barcode ${barcode} removed successfully!`);
          await loadInitialPageData();
        } else {
          toast.error(response?.message || "Failed to remove barcode");
        }
      } catch (err) {
        console.error("Error removing barcode:", err);
        toast.error(err?.response?.data?.message || "Failed to remove barcode");
      } finally {
        setAssigningBarcode((prev) => ({ ...prev, [lineItemId]: false }));
      }
    },
    [
      documentNumber,
      formInputs.erfTypeCode,
      rentItems,
      saleItems,
      loadInitialPageData,
    ],
  );

  const hideFailureModal = () => setShowFailureModal(false);

  // eslint-disable-next-line
  const handleSlabSelection = (data) => {
    setRentItems((prevRows) =>
      prevRows.map((row) => {
        if (row.local_id !== data.index) return row;

        let updatedItem = {
          ...row,
          rentSlab: data.value,
          rentSlabCode: data.codeValue,
          rentSlabDescription: data.descValue,
        };

        const selectedSlab = data.value;

        switch (selectedSlab) {
          case "Per Day":
            updatedItem.days = updatedItem.days || 0;
            break;
          case "7 Days":
            updatedItem.days = 7;
            updatedItem.toDate = calculateEndDate(updatedItem.fromDate, 7);
            break;
          case "15 Days":
            updatedItem.days = 15;
            updatedItem.toDate = calculateEndDate(updatedItem.fromDate, 15);
            break;
          case "30 Days":
            updatedItem.days = 30;
            updatedItem.toDate = calculateEndDate(updatedItem.fromDate, 30);
            break;
          default:
            break;
        }

        const calculatedTotals = calculateRentTotals(updatedItem);

        return { ...updatedItem, ...calculatedTotals };
      }),
    );
  };

  // handleApproverSelection
  const handleApproverSelection = useCallback((index, selectedData) => {
    if (!selectedData || !selectedData.name || selectedData.name === "Select")
      return;

    setFormInputs((prev) => {
      const newApprovers = [...prev.approvers];

      newApprovers[index] = {
        userId: selectedData.userId || "M000",
        category: selectedData.category || "SALES",
        name: selectedData.name,
      };

      //  Check if approvers array actually changed
      const hasChanged =
        JSON.stringify(prev.approvers) !== JSON.stringify(newApprovers);
      if (!hasChanged) {
        return prev; // Don't update if nothing changed
      }

      return { ...prev, approvers: newApprovers };
    });
  }, []);

  // Line Item Logic: Add
  // const handleGetSelectedMaterial = (selectedData) => {
  //   if (!Array.isArray(selectedData) || selectedData.length === 0) return;

  //   const processItems = (items) =>
  //     items.map((item, index) => ({
  //       local_id: `${Date.now()}-${index}`,

  //       // Material Reference
  //       materialCode: item.materialCode,
  //       materialDescription: item.materialDescription,
  //       barcode: item.barcode || "",

  //       // Reference Prices from Master
  //       masterMRP: item.mrPrice || 0,
  //       masterLRP: item.iphslrPrice || 0,
  //       masterUnitPrice: item.unitPrice || 0,

  //       // ERF Order Details
  //       itemType: activeItemType,
  //       orderedQuantity: 1,
  //       sellingPrice: item.unitPrice || 0,
  //       rentPerDay: item.rentPrice || 0,

  //       // Date fields (for Rent)
  //       fromDate: getTodaysData(),
  //       toDate: "",
  //       days: 0,

  //       // Financial Calculations
  //       netValue: 0,
  //       grossValue: 0,
  //       taxPercentage: 0,
  //       taxAmount: 0,

  //       // Security (for Rent)
  //       actualSecurityAmt: 0,
  //       securityAmt: 0,

  //       // Additional
  //       refundAmt: 0,
  //       refundDays: 0,
  //       orderUnitOfMeasure: item.unit || "EA",
  //       storageLocn: "Main Store",
  //       currencyCode: "INR",
  //     }));

  //   if (activeItemType === "Rent") {
  //     setRentItems((prev) => {
  //       const existingCodes = prev.map((item) => item.materialCode);
  //       const duplicates = selectedData.filter((item) =>
  //         existingCodes.includes(item.materialCode),
  //       );

  //       if (duplicates.length > 0) {
  //         toast.error(
  //           `Product(s) already exist in Rent list: ${duplicates
  //             .map((d) => d.materialCode)
  //             .join(", ")}`,
  //         );
  //         const newItems = selectedData.filter(
  //           (item) => !existingCodes.includes(item.materialCode),
  //         );
  //         if (newItems.length === 0) return prev;
  //         return [...prev, ...processItems(newItems)];
  //       }
  //       return [...prev, ...processItems(selectedData)];
  //     });
  //   } else {
  //     setSaleItems((prev) => {
  //       const existingCodes = prev.map((item) => item.materialCode);
  //       const duplicates = selectedData.filter((item) =>
  //         existingCodes.includes(item.materialCode),
  //       );

  //       if (duplicates.length > 0) {
  //         toast.error(
  //           `Product(s) already exist in ${activeItemType} list: ${duplicates
  //             .map((d) => d.materialCode)
  //             .join(", ")}`,
  //         );
  //         const newItems = selectedData.filter(
  //           (item) => !existingCodes.includes(item.materialCode),
  //         );
  //         if (newItems.length === 0) return prev;
  //         return [...prev, ...processItems(newItems)];
  //       }
  //       return [...prev, ...processItems(selectedData)];
  //     });
  //   }
  //   setModalShow(false);
  // };
  // =============================================================================
  // 1. handleGetSelectedMaterial - CORRECTED with all CreateERF keys
  // =============================================================================
  const handleGetSelectedMaterial = (selectedData) => {
    if (!Array.isArray(selectedData) || selectedData.length === 0) return;

    const processItems = (items) =>
      items.map((item, index) => {
        const qty = 1;
        const taxPercentage = parseFloat(item.taxCode) || 0;

        let netVal = 0;
        let taxAmt = 0;
        let grossVal = 0;

        if (activeItemType === "Rent") {
          const days = 0;
          const rentPerDay = parseFloat(item.rentPerDayPrice) || 0;
          const effectiveRentPrice = rentPerDay * days;

          netVal = qty * effectiveRentPrice;
          taxAmt = netVal * (taxPercentage / 100);
          grossVal = netVal + taxAmt;

          return {
            local_id: `${Date.now()}-${index}`,

            // Material Reference
            materialCode: item.materialCode,
            materialDescription: item.materialDescription,
            barcode: item.barcode || "",

            // Reference Prices from Master - MATCHING CreateERF
            masterMRP: parseFloat(item.mrPrice) || 0,
            masterSellingPrice: parseFloat(item.salePrice) || 0,
            masterUnitPrice: parseFloat(item.unitPrice) || 0,

            // ERF Order Details
            itemType: activeItemType,
            orderedQuantity: qty,
            sellingPrice: parseFloat(item.rentPerDayPrice) || 0,

            // Rent Prices - ALL FOUR SLABS
            rentPerDay: parseFloat(item.rentPerDayPrice) || 0,
            rent7Days: parseFloat(item.rent7DaysPrice) || 0,
            rent15Days: parseFloat(item.rent15DaysPrice) || 0,
            rent30Days: parseFloat(item.rent30DaysPrice) || 0,

            // Slab fields - DEFAULT
            rentSlab: "Per Day",
            rentSlabCode: "PER_DAY",
            rentSlabDescription: "PER_DAY",

            // Date fields (for Rent)
            fromDate: getTodaysData(),
            toDate: "",
            days: 0,

            // Financial Calculations
            netValue: parseFloat(netVal.toFixed(2)),
            grossValue: parseFloat(grossVal.toFixed(2)),
            taxPercentage: taxPercentage,
            taxAmount: parseFloat(taxAmt.toFixed(2)),

            // Security (for Rent)
            actualSecurityAmt: parseFloat(item.securityAmt) || 0,
            securityAmt: parseFloat(item.securityAmt) || 0,

            // Additional
            refundAmt: 0,
            refundDays: 0,
            orderUnitOfMeasure: item.unit || "EA",
            storageLocn: "Main Store",
            currencyCode: "INR",
          };
        } else {
          // For Sale or Service
          const sellingPrice = parseFloat(item.salePrice) || 0;

          netVal = qty * sellingPrice;
          taxAmt = netVal * (taxPercentage / 100);
          grossVal = netVal + taxAmt;

          return {
            local_id: `${Date.now()}-${index}`,

            // Material Reference
            materialCode: item.materialCode,
            materialDescription: item.materialDescription,
            barcode: item.barcode || "",

            // Reference Prices from Master - MATCHING CreateERF
            masterMRP: parseFloat(item.mrPrice) || 0,
            masterSellingPrice: parseFloat(item.salePrice) || 0,
            masterUnitPrice: parseFloat(item.unitPrice) || 0,

            // ERF Order Details
            itemType: activeItemType,
            orderedQuantity: qty,
            sellingPrice: parseFloat(item.salePrice) || 0,

            // Rent Prices (even for Sale items, for consistency)
            rentPerDay: parseFloat(item.rentPerDayPrice) || 0,
            rent7Days: parseFloat(item.rent7DaysPrice) || 0,
            rent15Days: parseFloat(item.rent15DaysPrice) || 0,
            rent30Days: parseFloat(item.rent30DaysPrice) || 0,

            // Date fields
            fromDate: getTodaysData(),
            toDate: "",
            days: 0,

            // Financial Calculations
            netValue: parseFloat(netVal.toFixed(2)),
            grossValue: parseFloat(grossVal.toFixed(2)),
            taxPercentage: taxPercentage,
            taxAmount: parseFloat(taxAmt.toFixed(2)),

            // Security
            actualSecurityAmt: parseFloat(item.securityAmt) || 0,
            securityAmt: parseFloat(item.securityAmt) || 0,

            // Additional
            refundAmt: 0,
            refundDays: 0,
            orderUnitOfMeasure: item.unit || "EA",
            storageLocn: "Main Store",
            currencyCode: "INR",
          };
        }
      });

    // Duplicate checking - use barcode like CreateERF
    if (activeItemType === "Rent") {
      setRentItems((prev) => {
        const existingCodes = prev.map((item) => item.barcode);
        const duplicates = selectedData.filter((item) =>
          existingCodes.includes(item.barcode),
        );

        if (duplicates.length > 0) {
          toast.error(
            `Product(s) already exist in Rent list: ${duplicates
              .map((d) => d.materialCode)
              .join(", ")}`,
          );
          const newItems = selectedData.filter(
            (item) => !existingCodes.includes(item.barcode),
          );
          if (newItems.length === 0) return prev;
          return [...prev, ...processItems(newItems)];
        }
        return [...prev, ...processItems(selectedData)];
      });
    } else {
      setSaleItems((prev) => {
        const existingCodes = prev.map((item) => item.barcode);
        const duplicates = selectedData.filter((item) =>
          existingCodes.includes(item.barcode),
        );

        if (duplicates.length > 0) {
          toast.error(
            `Product(s) already exist in ${activeItemType} list: ${duplicates
              .map((d) => d.materialCode)
              .join(", ")}`,
          );
          const newItems = selectedData.filter(
            (item) => !existingCodes.includes(item.barcode),
          );
          if (newItems.length === 0) return prev;
          return [...prev, ...processItems(newItems)];
        }
        return [...prev, ...processItems(selectedData)];
      });
    }
    setModalShow(false);
  };

  // Line Item Logic: Remove
  const removeItemRow = (local_id, type) => {
    if (type === "Rent") {
      setRentItems((prev) => prev.filter((item) => item.local_id !== local_id));
    } else {
      setSaleItems((prev) => prev.filter((item) => item.local_id !== local_id));
    }
  };

  // =============================================================================
  // 2. handleLineItemChange - COMPLETE with ALL CreateERF logic
  // =============================================================================
  const handleLineItemChange = (local_id, e, type) => {
    const { name, value } = e.target;

    const updateLogic = (prev) => {
      return prev.map((item) => {
        if (item.local_id === local_id) {
          let updatedItem = { ...item, [name]: value };

          // =====================================================================
          // RENT LOGIC
          // =====================================================================
          if (item.itemType === "Rent") {
            // ===== Date Calculations =====
            if (name === "fromDate") {
              if (updatedItem.rentSlab === "Per Day") {
                if (updatedItem.days > 0) {
                  updatedItem.toDate = calculateEndDate(
                    value,
                    updatedItem.days,
                  );
                } else if (updatedItem.toDate) {
                  updatedItem.days = calculateDays(value, updatedItem.toDate);
                }
              } else {
                // For fixed slabs, recalculate toDate
                updatedItem.toDate = calculateEndDate(value, updatedItem.days);
              }

              const calculated = calculateRentTotals(updatedItem);
              updatedItem = { ...updatedItem, ...calculated };
            }

            // ===== Days Change (only for Per Day slab) =====
            if (name === "days" && updatedItem.rentSlab === "Per Day") {
              const days = parseInt(value) || 0;
              updatedItem.toDate = calculateEndDate(updatedItem.fromDate, days);

              const calculated = calculateRentTotals(updatedItem);
              updatedItem = { ...updatedItem, ...calculated };
            }

            // ===== To Date Change (only for Per Day slab) =====
            if (name === "toDate" && updatedItem.rentSlab === "Per Day") {
              updatedItem.days = calculateDays(updatedItem.fromDate, value);

              const calculated = calculateRentTotals(updatedItem);
              updatedItem = { ...updatedItem, ...calculated };
            }

            // ===== Manual Rate Editing =====
            if (name === "sellingPrice") {
              const qty = parseFloat(updatedItem.orderedQuantity) || 0;
              const days = parseFloat(updatedItem.days) || 0;
              const rate = parseFloat(value) || 0;
              const tax = parseFloat(updatedItem.taxPercentage) || 0;

              let netVal = 0;
              if (updatedItem.rentSlab === "Per Day") {
                // For Per Day: Rate is per-day price
                netVal = qty * rate * days;
              } else {
                // For fixed slabs: Rate represents total rent for the period
                netVal = qty * rate;
              }

              const taxAmt = netVal * (tax / 100);
              const grossVal = netVal + taxAmt;

              updatedItem.netValue = parseFloat(netVal.toFixed(2));
              updatedItem.taxAmount = parseFloat(taxAmt.toFixed(2));
              updatedItem.grossValue = parseFloat(grossVal.toFixed(2));
            }

            // ===== Quantity or Tax% Change =====
            if (
              (name === "orderedQuantity" || name === "taxPercentage") &&
              name !== "sellingPrice"
            ) {
              const calculated = calculateRentTotals(updatedItem);
              updatedItem = { ...updatedItem, ...calculated };
            }

            // ===== Security Amount Changes =====
            if (name === "securityAmt" || name === "actualSecurityAmt") {
              // Values already updated, totals will recalculate via useMemo
            }
          }

          // =====================================================================
          // SALE/SERVICE LOGIC
          // =====================================================================
          if (item.itemType === "Sale" || item.itemType === "Service") {
            // ===== Reverse Calculation (when Total is edited) =====
            if (name === "grossValue") {
              const grossVal = parseFloat(value) || 0;
              const qty = parseFloat(updatedItem.orderedQuantity) || 1;
              const tax = parseFloat(updatedItem.taxPercentage) || 0;

              const netVal = grossVal / (1 + tax / 100);
              const unitPrice = netVal / qty;
              const taxAmt = grossVal - netVal;

              updatedItem.netValue = parseFloat(netVal.toFixed(2));
              updatedItem.sellingPrice = parseFloat(unitPrice.toFixed(2));
              updatedItem.taxAmount = parseFloat(taxAmt.toFixed(2));
            }

            // ===== Tax % Changed =====
            else if (name === "taxPercentage") {
              const qty = parseFloat(updatedItem.orderedQuantity) || 0;
              const price = parseFloat(updatedItem.sellingPrice) || 0;
              const tax = parseFloat(value) || 0;

              const netVal = qty * price;
              const taxAmt = netVal * (tax / 100);
              const grossVal = netVal + taxAmt;

              updatedItem.netValue = parseFloat(netVal.toFixed(2));
              updatedItem.taxAmount = parseFloat(taxAmt.toFixed(2));
              updatedItem.grossValue = parseFloat(grossVal.toFixed(2));
            }

            // ===== Forward Calculation (Qty or Rate changed) =====
            else if (name === "orderedQuantity" || name === "sellingPrice") {
              const qty = parseFloat(updatedItem.orderedQuantity) || 0;
              const price = parseFloat(updatedItem.sellingPrice) || 0;
              const tax = parseFloat(updatedItem.taxPercentage) || 0;

              const netVal = qty * price;
              const taxAmt = netVal * (tax / 100);
              const grossVal = netVal + taxAmt;

              updatedItem.netValue = parseFloat(netVal.toFixed(2));
              updatedItem.taxAmount = parseFloat(taxAmt.toFixed(2));
              updatedItem.grossValue = parseFloat(grossVal.toFixed(2));
            }
          }

          return updatedItem;
        }
        return item;
      });
    };

    if (type === "Rent") {
      setRentItems((prev) => updateLogic(prev));
    } else {
      setSaleItems((prev) => updateLogic(prev));
    }
  };

  const addProductDetails = (type) => {
    setActiveItemType(type || formInputs.erfType);
    setModalShow(true);
  };
  const hideModal = () => setModalShow(false);

  // Fetch All Hospitals
  const fetchHospitalList = async () => {
    setIsLoadingHospitals(true);
    try {
      const payload = {
        queryName: "Get_All_Hospital_Names",
        module: "",
        page: 1,
        per_page: 3000, // Get all hospitals
        timeZone: "Asia/Calcutta",
      };

      const response = await ItemService.generateQuery(payload);

      if (response?.status === 200 && Array.isArray(response.data)) {
        setHospitalList(response.data);
      } else {
        setHospitalList([]);
      }
    } catch (err) {
      console.error("Error fetching hospitals:", err);
      toast.error("Failed to load hospital list");
      setHospitalList([]);
    } finally {
      setIsLoadingHospitals(false);
    }
  };

  // Fetch All Doctors (for "Doctor" type)
  const fetchAllDoctors = async () => {
    setIsLoadingDoctors(true);
    try {
      const payload = {
        queryName: "Get_All_Doctors",
        module: "",
        page: 1,
        per_page: 3000, // Get all doctors
        timeZone: "Asia/Calcutta",
      };

      const response = await ItemService.generateQuery(payload);

      if (response?.status === 200 && Array.isArray(response.data)) {
        // Format for dropdown
        const formattedDoctors = response.data.map((doc) => ({
          id: doc.userId,
          name: doc.doctorName,
          code: doc.userId,
          userId: doc.userId,
          doctorName: doc.doctorName,
          hospitalName: doc.hospitalName || doc.doctorHospitalName,
          description: `${doc.doctorName} - ${doc.hospitalName || doc.doctorHospitalName}`,
          ...doc, // Keep all original data
        }));

        setDoctorsList(formattedDoctors);
      } else {
        setDoctorsList([]);
      }
    } catch (err) {
      console.error("Error fetching doctors:", err);
      toast.error("Failed to load doctors list");
      setDoctorsList([]);
    } finally {
      setIsLoadingDoctors(false);
    }
  };

  // Call this on component mount if needed
  useEffect(() => {
    let isMounted = true;

    const loadHospitals = async () => {
      if (erfForType === "Hospital") {
        setErfIsLoadingHospitals(true);

        try {
          const payload = {
            queryName: "getSupplierList",
            module: "",
            page: 1,
            per_page: 1000,
            timeZone: "Asia/Calcutta",
            rowFilter: {
              $and: [
                {
                  "vendorCategory.vendorCategoryCode": "V04",
                },
              ],
            },
          };

          const response = await ItemService.generateQuery(payload);

          if (
            isMounted &&
            response?.status === 200 &&
            Array.isArray(response.data)
          ) {
            const formattedHospitals = response.data.map((hospital) => ({
              id: hospital.userId || hospital._id,
              name: hospital.hospitalName || hospital.organisationName,
              userId: hospital.userId,
              hospitalName: hospital.hospitalName,
              organisationName: hospital.organisationName,
              AssociateNumber: hospital.AssociateNumber,
              mobileNr: hospital.mobileNr,
              email: hospital.email,
              address: hospital.address,
              address2: hospital.address2,
              city: hospital.city,
              state: hospital.state,
              cityPostalCode: hospital.cityPostalCode,
              certifications: hospital.certifications || [], // Needed for GST auto-fill
            }));

            setErfHospitalList(formattedHospitals);
          } else if (isMounted) {
            setErfHospitalList([]);
          }
        } catch (err) {
          console.error("Error fetching ERF hospitals:", err);
          if (isMounted) {
            toast.error("Failed to load ERF hospital list");
            setErfHospitalList([]);
          }
        } finally {
          if (isMounted) {
            setErfIsLoadingHospitals(false);
          }
        }
      } else {
        if (isMounted) {
          setErfHospitalList([]);
        }
      }
    };

    loadHospitals();

    // Cleanup: prevent state updates after unmount
    return () => {
      isMounted = false;
    };
  }, [erfForType]);

  // Fetch Doctors by Hospital
  const fetchDoctorsByHospital = async (hospitalName) => {
    setIsLoadingDoctors(true);
    try {
      const payload = {
        queryName: "Get_All_Doctors",
        module: "",
        page: 1,
        per_page: 3000,
        timeZone: "Asia/Calcutta",
        rowFilter: {
          $and: [
            {
              hospitalName: hospitalName,
            },
          ],
        },
      };

      const response = await ItemService.generateQuery(payload);

      if (response?.status === 200 && Array.isArray(response.data)) {
        // Format for dropdown
        const formattedDoctors = response.data.map((doc) => ({
          id: doc.userId,
          name: doc.doctorName,
          code: doc.userId,
          userId: doc.userId,
          doctorName: doc.doctorName,
          hospitalName: doc.hospitalName || doc.doctorHospitalName,
          description: `${doc.doctorName} (${doc.userId})`,
          ...doc, // Keep all original data for auto-fill
        }));

        setDoctorsList(formattedDoctors);
      } else {
        setDoctorsList([]);
        toast.info(`No doctors found for ${hospitalName}`);
      }
    } catch (err) {
      console.error("Error fetching doctors by hospital:", err);
      toast.error("Failed to load doctors for selected hospital");
      setDoctorsList([]);
    } finally {
      setIsLoadingDoctors(false);
    }
  };

  const getDataWithTotal = (items) => {
    if (items.length === 0) return [];

    const typeTotal = items.reduce(
      (acc, item) => {
        acc.netValue += parseFloat(item.netValue || 0);
        acc.grossValue += parseFloat(item.grossValue || 0);
        acc.taxAmount += parseFloat(item.taxAmount || 0);
        if (item.itemType === "Rent") {
          acc.actualSecurityAmt += parseFloat(item.actualSecurityAmt || 0);
          acc.securityAmt += parseFloat(item.securityAmt || 0);
        }
        return acc;
      },
      {
        netValue: 0,
        grossValue: 0,
        taxAmount: 0,
        actualSecurityAmt: 0,
        securityAmt: 0,
      },
    );

    return [
      ...items,
      {
        isTotal: true,
        local_id: "total",
        netValue: typeTotal.netValue.toFixed(2),
        grossValue: typeTotal.grossValue.toFixed(2),
        taxAmount: typeTotal.taxAmount.toFixed(2),
        actualSecurityAmt: typeTotal.actualSecurityAmt.toFixed(2),
        securityAmt: typeTotal.securityAmt.toFixed(2),
      },
    ];
  };

  // =============================================================================
  // 3. handleUpdate - COMPLETE with ALL CreateERF validations
  // =============================================================================
  const incrementVersion = (version) => {
    // remove 'V' and convert to number
    const num = parseInt(version.replace("V", ""), 10);

    // increment and return with V prefix
    return `V${num + 1}`;
  };
  const handleUpdate = async (newRemarks) => {
    const validationErrors = {};
    let hasError = false;

    // ===== 1. Basic Fields Validation =====
    if (!validateRequired(formInputs.patientName)) {
      validationErrors.patientName = message.FILL_REQUIRED_FIELD;
      hasError = true;
    }
    if (!validateRequired(formInputs.contactNumber)) {
      validationErrors.contactNumber = message.FILL_REQUIRED_FIELD;
      hasError = true;
    }
    if (!validateRequired(formInputs.aadharNo)) {
      validationErrors.aadharNo = message.FILL_REQUIRED_FIELD;
      hasError = true;
    }
    if (formInputs.idProof && formInputs.idProof !== "Select") {
      if (!validateRequired(formInputs.idProofNumber)) {
        validationErrors.idProofNumber = `Please enter ${formInputs.idProof} number`;
        hasError = true;
      }
    }

    // ===== 2. Approval Process Validation =====
    if (
      APPROVAL_REQUIRED_CASES.includes(formInputs.privilegeCase?.toUpperCase())
    ) {
      const requiredCount = parseInt(formInputs.approvalLevel);
      if (!requiredCount) {
        toast.error("Please select an Approval Level");
        return;
      }

      const selectedCount = formInputs.approvers.filter(
        (a) => a && a.userId,
      ).length;

      if (selectedCount < requiredCount) {
        toast.error(`Please select all ${requiredCount} required approver(s)`);
        return;
      }
    }

    // ===== 3. Specific Item Logic Validation =====
    switch (formInputs.erfType) {
      case "Sale":
        if (saleItems.length === 0) {
          toast.error("Please add at least one Sale product.");
          return;
        }
        break;
      case "Rent":
        if (rentItems.length === 0) {
          toast.error("Please add at least one Rent product.");
          return;
        }
        break;
      case "Sale & Rent":
        if (rentItems.length === 0) {
          toast.error("Please add at least one Rent product.");
          return;
        }
        if (saleItems.length === 0) {
          toast.error("Please add at least one Sale product.");
          return;
        }
        break;
      case "Service":
        if (saleItems.length === 0) {
          toast.error("Please add at least one Service item.");
          return;
        }
        break;
      case "Nursing Service":
        // No product validation needed
        break;
      default:
        toast.error("Please select a valid ERF Type.");
        return;
    }

    // ===== 4. Qty & Price Validation =====
    const finalItems = [...rentItems, ...saleItems];
    const invalidQty = finalItems.filter(
      (item) => (parseFloat(item.orderedQuantity) || 0) < 1,
    );

    if (invalidQty.length > 0) {
      toast.error("Quantity must be at least 1 for all products");
      return;
    }

    const privilegeSettings =
      PRIVILEGE_SETTINGS[formInputs.privilegeCase] ||
      DEFAULT_PRIVILEGE_SETTINGS;

    if (!privilegeSettings.allowSellBelowLRP) {
      const invalidSaleItems = saleItems.filter(
        (item) =>
          parseFloat(item.sellingPrice) < parseFloat(item.masterSellingPrice),
      );
      if (invalidSaleItems.length > 0) {
        toast.error(
          "Sale/Service Unit Price cannot be less than Master Selling Price for this Privilege Case",
        );
        return;
      }
    }

    setValidation((prev) => ({ ...prev, ...validationErrors }));

    if (hasError) {
      setErrorFields(Object.keys(validationErrors));
      setShowFailureModal(true);
      return;
    }

    setLoading(true);
    try {
      const triggerWorkflow = APPROVAL_REQUIRED_CASES.includes(
        formInputs.privilegeCase?.toUpperCase(),
      );

      // ===== 5. Convert items to numbers =====
      const processedRentItems = rentItems.map((item) =>
        convertToNumbers(item),
      );
      const processedSaleItems = saleItems.map((item) =>
        convertToNumbers(item),
      );

      // ===== 6. Construct Payload =====
      const payloadData = {
        ...formInputs,
        erfTypeCode: formInputs.erfTypeCode,
        erfTypeDescription: formInputs.erfTypeDescription,

        // Approval fields
        levelOfApproval: formInputs.approvalLevel,
        approverList: formInputs.approvers,

        // Approval Workflow Fields
        triggerWorkflow: triggerWorkflow,
        approverUserId1:
          triggerWorkflow && formInputs.approvers[0]
            ? formInputs.approvers[0].userId
            : "",
        approverUsername1:
          triggerWorkflow && formInputs.approvers[0]
            ? formInputs.approvers[0].name
            : "",
        approverUserId2:
          triggerWorkflow && formInputs.approvers[1]
            ? formInputs.approvers[1].userId
            : "",
        approverUsername2:
          triggerWorkflow && formInputs.approvers[1]
            ? formInputs.approvers[1].name
            : "",

        createdBy: currentUserId,

        // Convert all calculated amounts to numbers
        netAmount: parseFloat(netAmount),
        balanceAmount: parseFloat(balanceAmount),
        balanceSecurityAmt: parseFloat(balanceSecurityAmt),

        // Convert form input amounts to numbers
        cartage: parseFloat(formInputs.cartage) || 0,
        installationCharges: parseFloat(formInputs.installationCharges) || 0,
        receivedAmount: parseFloat(formInputs.receivedAmount) || 0,
        cashAmount: parseFloat(formInputs.cashAmount) || 0,
        receivedSecurityAmt: parseFloat(formInputs.receivedSecurityAmt) || 0,
        securityCashAmt: parseFloat(formInputs.securityCashAmt) || 0,
        securityModeCash: parseFloat(formInputs.securityModeCash) || 0,
        age: formInputs.age ? parseFloat(formInputs.age) : undefined,
        weight: formInputs.weight ? parseFloat(formInputs.weight) : undefined,
        version: incrementVersion(formInputs?.version),
        updateRemarks: newRemarks,
      };

      // Delete unnecessary fields from update response
      if (payloadData.data) {
        delete payloadData.data;
      }
      if (payloadData._id) {
        delete payloadData._id;
      }

      // ===== 7. Specific Logic for Payload keys =====
      if (formInputs.erfType === "Service") {
        payloadData.rentItems = [];
        payloadData.saleItems = [];
        payloadData.serviceItems = processedSaleItems;
      } else if (formInputs.erfType === "Nursing Service") {
        payloadData.rentItems = [];
        payloadData.saleItems = [];
        payloadData.serviceItems = [];
      } else {
        payloadData.rentItems = processedRentItems;
        payloadData.saleItems = processedSaleItems;
        payloadData.serviceItems = [];
      }

      await ItemService.updateEquipmentRentForm(payloadData);

      toast.success("ERF Updated Successfully");
      setEdit(true);
      setDisabled(true);
      navigate(Constants.CUSTOMER_V5_MR_ERF_LIST);
      // Optionally reload data to see updated values
      // loadInitialPageData();
    } catch (err) {
      toast.error("Failed to update ERF");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // =============================================================================
  // TABLE COLUMNS CONFIG
  // =============================================================================
  const [extensionData, setExtensionData] = useState([]);
  // const [loading, setLoading] = useState(false);
  const detailedPage = (row) => {
    // For documentNumber column
    // dispatch(clearEquipmentRentNumbers());
    dispatch(setEquipmentRentDocumentNumber(row.documentNumber));
    navigate(CustomerConstants.CUSTOMER_V5_MR_EXTENSION_ERF_DETAILS);
  };

  const freshColumns = [
    {
      name: "Sale Point",
      width: "120px",
      cell: (row) => (
        <InputField
          className="inputBox"
          name="salePoint"
          value={formInputs.salePoint}
          disabled={true}
        />
      ),
    },
    {
      name: "Version",
      width: "100px",
      cell: (row) => (
        <InputField
          className="inputBox"
          // name="version"
          name="version"
          value={row.version}
          disabled={true}
        />
      ),
    },
    {
      name: "Material Code",
      width: "180px",
      cell: (row) => (
        <InputField
          className="inputBox"
          name="materialCode"
          value={row.materialCode}
          disabled={true}
        />
      ),
    },
    {
      name: "Bar Code12",
      width: "180px",
      cell: (row) => (
        <InputField
          className="inputBox"
          name=""
          value={row.barcode}
          disabled={true}
        />
      ),
    },

    {
      name: "ERF Number",
      width: "160px",
      cell: (row) => (
        <InputField
          className="inputBox"
          name="equipmentNr"
          value={formInputs.equipmentNr}
          disabled={true}
        />
      ),
    },
    {
      name: "EquipMent Rent Nr",
      width: "160px",
      cell: (row) => (
        <InputField
          className="inputBox"
          name="equipmentRentNr"
          value={formInputs.equipmentRentNr}
          disabled={true}
        />
      ),
    },
    {
      name: "Description",
      cell: (row) => (
        <InputField
          className="inputBox"
          name="materialDescription"
          value={row.materialDescription}
          disabled={true}
        />
      ),
    },
    {
      name: "From Date",
      cell: (row) =>
        row.isTotal ? null : (
          <InputField
            className="inputBox"
            name="fromDate"
            value={row.fromDate}
            disabled={true}
          />
        ),
    },
    {
      name: "To Date",
      cell: (row) =>
        row.isTotal ? null : (
          <InputField
            className="inputBox"
            name="toDate"
            value={row.toDate}
            disabled={true}
          />
        ),
    },
    {
      name: "Days",
      width: "120px",
      cell: (row) =>
        row.isTotal ? null : (
          <InputField
            className="inputBox text-end"
            name="days"
            value={row.days}
            disabled={true}
          />
        ),
    },
    {
      name: "Gross Amount",
      width: "150px",
      cell: (row) =>
        row.isTotal ? (
          <div className="fw-bold text-end w-100">{row.grossValue}</div>
        ) : (
          <InputField
            className="inputBox text-end"
            name="grossValue"
            value={row.grossValue}
            disabled={true}
          />
        ),
    },
  ];

  const extensionColumns = [
    {
      name: "View Details",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button className="btnInfo" onClick={() => detailedPage(row)}>
          {/* {formInputs.equipmentRentNr || ""} */}
          View
        </button>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Sale Point",
      width: "120px",
      cell: (row) => (
        <InputField
          className="inputBox"
          name="salePoint"
          value={formInputs.salePoint}
          disabled={true}
        />
      ),
    },
    {
      name: "Version",
      width: "100px",
      cell: (row) => (
        <InputField
          className="inputBox"
          name="version"
          value={row.version}
          disabled={true}
        />
      ),
    },
    {
      name: "Material Code",
      width: "160px",
      cell: (row) => (
        <InputField
          className="inputBox"
          name="materialCode"
          value={row.materialCode}
          disabled={true}
        />
      ),
    },
    {
      name: "Bar Code",
      width: "160px",
      cell: (row) => (
        <InputField
          className="inputBox"
          name="barcode"
          value={row.barcode}
          disabled={true}
        />
      ),
    },
    {
      name: "ERF Number",
      width: "160px",
      cell: (row) => (
        <InputField
          className="inputBox"
          name="equipmentNr"
          value={formInputs.equipmentNr}
          disabled={true}
        />
      ),
    },
    {
      name: "EquipMent Rent Nr",
      width: "160px",
      cell: (row) => (
        <InputField
          className="inputBox"
          name="equipmentRentNr"
          value={row.equipmentRentNr}
          disabled={true}
        />
      ),
    },
    {
      name: "From Date",
      width: "160px",
      cell: (row) => (
        <InputField
          className="inputBox"
          name="extensionFromDate"
          value={row.extensionFromDate}
          disabled={true}
        />
      ),
    },
    {
      name: "To Date",
      width: "160px",
      cell: (row) => (
        <InputField
          className="inputBox"
          name="extensionToDate"
          value={row.extensionToDate}
          disabled={true}
        />
      ),
    },
    {
      name: "Extended Days",
      width: "130px",
      cell: (row) => (
        <InputField
          className="inputBox text-end"
          name="extendedDays"
          value={row.extendedDays}
          disabled={true}
        />
      ),
    },
    {
      name: "Extension Amount",
      width: "160px",
      cell: (row) => (
        <InputField
          className="inputBox text-end"
          name="extensionAmount"
          value={row.extensionAmount}
          disabled={true}
        />
      ),
    },
    {
      name: "Created By",
      width: "140px",
      cell: (row) => (
        <InputField
          className="inputBox"
          name="createdBy"
          value={row.createdBy}
          disabled={true}
        />
      ),
    },
  ];

  const getColumns = (type) => {
    const privilegeSettings =
      PRIVILEGE_SETTINGS[formInputs.privilegeCase] ||
      DEFAULT_PRIVILEGE_SETTINGS;

    const isSaleAmountEditable =
      (type === "Sale" || type === "Service") && privilegeSettings.editAmount;
    const isSaleTaxEditable =
      (type === "Sale" || type === "Service") && privilegeSettings.editTax;

    const isEditable = !disabled && isFormEnabled;

    const baseCols = [
      {
        name: "Product Code",
        width: "180px",
        cell: (row) =>
          row.isTotal ? (
            <div className="fw-bold text-end w-100">Total</div>
          ) : (
            <InputField
              className="inputBox"
              name="materialCode"
              value={row.materialCode}
              disabled={true}
            />
          ),
      },
      // {
      //   name: "Barcode",
      //   width: "180px",
      //   cell: (row) =>
      //     row.isTotal ? (
      //       <div className="fw-bold text-end w-100">Total</div>
      //     ) : (
      //       <InputField
      //         className="inputBox"
      //         name="barcode"
      //         value={row.barcode}
      //         disabled={true}
      //       />
      //     ),
      // },
      {
        name: "Product Details",
        width: "250px",
        cell: (row) =>
          row.isTotal ? null : (
            <TextAreaField
              className="inputBox"
              name="materialDescription"
              value={row.materialDescription}
              onChange={(e) =>
                handleLineItemChange(
                  row.local_id,
                  e,
                  type === "Rent" ? "Rent" : "Sale",
                )
              }
              disabled={!isEditable}
            />
          ),
      },
    ];

    let middleCols = [];
    if (type === "Rent") {
      middleCols = [
        {
          name: "Extenssion",
          cell: (row) =>
            row.isTotal ? null : (
              <button
                className="btn btnTable"
                onClick={() => showExtenssionModla(row)}
              >
                Add Extenssion
              </button>
            ),
          sortable: true,
          width: "200px",
          omit: !formInputs?.extension,
        },
        // {
        //   name: "Select Slab",
        //   cell: (row) =>
        //     row.isTotal ? null : (
        //       <TableDropdownMenu
        //         index={row?.local_id}
        //         label={"Select Slab"}
        //         data={RENT_SLAB_OPTIONS}
        //         id={"rentSlab"}
        //         name={"rentSlab"}
        //         code={"rentSlabCode"}
        //         description={"rentSlabDescription"}
        //         onChange={handleSlabSelection}
        //         value={row?.rentSlab}
        //         codeValue={row?.rentSlabCode}
        //         descValue={row?.rentSlabDescription}
        //       />
        //     ),
        //   sortable: true,
        //   width: "200px",
        // },
        {
          name: "From",
          width: "150px",
          cell: (row) =>
            row.isTotal ? null : (
              <InputField
                className="inputBox"
                type="date"
                name="fromDate"
                value={row.fromDate}
                onChange={(e) => handleLineItemChange(row.local_id, e, "Rent")}
                disabled={!isEditable}
              />
            ),
        },
        {
          name: "To",
          width: "150px",
          cell: (row) =>
            row.isTotal ? null : (
              <InputField
                className="inputBox"
                type="date"
                name="toDate"
                value={row.toDate}
                disabled
              />
            ),
        },
        {
          name: "Days",
          width: "120px",
          cell: (row) =>
            row.isTotal ? null : (
              <InputField
                className="inputBox"
                type="number"
                name="days"
                value={row.days}
                onChange={(e) => handleLineItemChange(row.local_id, e, "Rent")}
                disabled={!isEditable || row.rentSlab !== "Per Day"} // CRITICAL
              />
            ),
        },
        {
          name: "Rent/Day",
          width: "120px",
          cell: (row) =>
            row.isTotal ? null : (
              <InputField
                className="inputBox"
                type="number"
                name="rentPerDay"
                value={row.rentPerDay || 0}
                disabled={true}
              />
            ),
        },
      ];
    }

    const financialCols = [
      {
        name: "Qty.",
        width: "120px",
        cell: (row) =>
          row.isTotal ? null : (
            <InputField
              className="inputBox"
              type="number"
              name="orderedQuantity"
              value={row.orderedQuantity}
              min="1"
              onChange={(e) =>
                handleLineItemChange(
                  row.local_id,
                  e,
                  type === "Rent" ? "Rent" : "Sale",
                )
              }
              disabled={true}
            />
          ),
      },
      {
        name: "MRP.",
        width: "120px",
        cell: (row) =>
          row.isTotal ? null : (
            <InputField
              className="inputBox"
              type="number"
              name="masterMRP"
              value={row.masterMRP || 0}
              disabled={true}
            />
          ),
      },
      {
        name: "Selling Price",
        width: "120px",
        cell: (row) =>
          row.isTotal ? null : (
            <InputField
              className="inputBox"
              type="number"
              name="sellingPrice"
              value={row.sellingPrice}
              onChange={(e) =>
                handleLineItemChange(
                  row.local_id,
                  e,
                  type === "Rent" ? "Rent" : "Sale",
                )
              }
              disabled={!isEditable && type !== "Rent"}
            />
          ),
      },

      {
        name: "Net Value",
        width: "120px",
        cell: (row) =>
          row.isTotal ? (
            <div className="fw-bold">{row.netValue}</div>
          ) : (
            <InputField
              className="inputBox"
              type="number"
              name="netValue"
              value={row.netValue}
              disabled={true}
            />
          ),
      },
      {
        name: "GST (%)",
        width: "100px",
        cell: (row) =>
          row.isTotal ? (
            <div className="fw-bold">Total</div>
          ) : (
            <InputField
              className="inputBox"
              type="number"
              name="taxPercentage"
              value={row.taxPercentage}
              onChange={(e) =>
                handleLineItemChange(
                  row.local_id,
                  e,
                  type === "Rent" ? "Rent" : "Sale",
                )
              }
              disabled={!isEditable || (type !== "Rent" && !isSaleTaxEditable)}
            />
          ),
      },
      {
        name: "Tax Amount",
        width: "120px",
        cell: (row) =>
          row.isTotal ? (
            <div className="fw-bold">{row.taxAmount}</div>
          ) : (
            <InputField
              className="inputBox"
              type="number"
              name="taxAmount"
              value={row.taxAmount}
              disabled={true}
            />
          ),
      },
      {
        name: "Total",
        width: "120px",
        cell: (row) =>
          row.isTotal ? (
            <div className="fw-bold">{row.grossValue}</div>
          ) : (
            <InputField
              className="inputBox"
              type="number"
              name="grossValue"
              value={row.grossValue}
              onChange={(e) =>
                handleLineItemChange(
                  row.local_id,
                  e,
                  type === "Rent" ? "Rent" : "Sale",
                )
              }
              disabled={
                !isEditable || (type !== "Rent" && !isSaleAmountEditable)
              }
            />
          ),
      },
    ];

    let endCols = [];
    if (type === "Rent") {
      endCols = [
        {
          name: "Actual Security",
          width: "100px",
          cell: (row) =>
            row.isTotal ? (
              <div className="fw-bold">{row.actualSecurityAmt}</div>
            ) : (
              <InputField
                className="inputBox"
                type="number"
                name="actualSecurityAmt"
                value={row.actualSecurityAmt}
                onChange={(e) => handleLineItemChange(row.local_id, e, "Rent")}
                disabled={!isEditable}
              />
            ),
        },
        {
          name: "Security",
          width: "100px",
          cell: (row) =>
            row.isTotal ? (
              <div className="fw-bold">{row.securityAmt}</div>
            ) : (
              <InputField
                className="inputBox"
                type="number"
                name="securityAmt"
                value={row.securityAmt}
                onChange={(e) => handleLineItemChange(row.local_id, e, "Rent")}
                disabled={!isEditable}
              />
            ),
        },
      ];
    }

    const actionCol = [
      {
        name: "Action",
        width: "80px",
        cell: (row) =>
          row.isTotal || !isEditable ? null : (
            <button
              className="btn btn-danger btn-sm mt-1"
              onClick={() =>
                removeItemRow(row.local_id, type === "Rent" ? "Rent" : "Sale")
              }
            >
              <i className="bi bi-trash3"></i>
            </button>
          ),
      },
    ];
    const storeActionCols = false
      ? [
          {
            name: "Barcode Management",
            width: "350px",
            cell: (row) =>
              row.isTotal ? null : (
                <BarcodeSelectorMRCustomerV5
                  lineItemId={row.local_id}
                  materialCode={row.materialCode}
                  currentBarcode={row.barcode}
                  equipmentItemNr={row.equipmentItemNr || ""}
                  onFetchBarcodes={fetchBarcodesForMaterial}
                  barcodeOptions={barcodeOptionsMap[row.materialCode] || []}
                  onAssign={handleBarcodeAssignment}
                  onRemove={handleBarcodeRemoval}
                  disabled={disabled}
                  isAssigning={assigningBarcode[row.local_id] || false}
                />
              ),
          },
        ]
      : [];

    return [
      ...baseCols,
      ...middleCols,
      ...financialCols,
      ...endCols,
      ...actionCol,
      ...storeActionCols,
    ];
  };

  const customStyles = {
    rows: {
      style: (row) => ({
        backgroundColor: row.isTotal ? "#cfe2ff" : "inherit",
        color: row.isTotal ? "#084298" : "inherit",
        fontWeight: row.isTotal ? "bold" : "normal",
      }),
    },
  };
  //handle reamarks
  const [updateModalShow, setUpdateModalShow] = useState(false);

  //update remarsk modal
  // eslint-disable-next-line
  const showApproveModal = async (name) => {
    setUpdateModalShow(true);
  };
  const updateHideModal = () => {
    setUpdateModalShow(false);
  };

  const handleValueChange = (remarks) => {
    const incrementVersion = (version = "V0") => {
      const num = parseInt(version.replace("V", ""), 10) || 0;
      return `V${num + 1}`;
    };

    const newVersion = incrementVersion(formInputs.version);

    const newRemarks = [
      ...(formInputs.extenssion || []),
      {
        remark: remarks,
        version: newVersion,
      },
    ];

    setFormInputs((prev) => ({
      ...prev,
      version: newVersion, // ✅ header updated
      updateRemarks: newRemarks, // ✅ extension updated
    }));

    handleUpdate(newRemarks);
  };

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  const remarkLineItemColInfo = [
    {
      name: "Remarks",
      cell: (row) => <span>{row?.remark || ""} </span>,
      width: "180px",
    },
    {
      name: "Version",
      cell: (row) => <span>{row?.version || ""} </span>,
      width: "180px",
    },
  ];
  // eslint-disable-next-line
  const remarkItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(remarkLineItemColInfo);
    setModalTitle("Updated Remarks / Version");
    setItemLevelModalShow(true);
  };
  //handle Chnage box
  // const handleCheckBoxInputChange = (e) => {
  //   const { name, checked } = e.target;

  //   setFormInputs((prev) => ({
  //     ...prev,
  //     [name]: checked,
  //   }));
  // };
  //extended modal
  const [getModalShowExtenssionModal, setModalShowExtenssionModal] =
    useState(false);
  const [getExtenssionData, setExtenssionData] = useState(false);

  const showExtenssionModla = (data) => {
    setModalShowExtenssionModal(true);
    setExtenssionData(data);
  };

  const hideModalExtenssionModal = () => {
    setModalShowExtenssionModal(false);
  };
  //extension model save
  const handleSaveExtensions = (extensionData) => {
    setRentItems((prevItems) =>
      prevItems.map((item) =>
        item.local_id === extensionData.local_id
          ? {
              ...item,
              extensionItemsdetails: extensionData.extensionItemsdetails || [],
            }
          : item,
      ),
    );
  };
  const userDataPC = JSON.parse(localStorage.getItem("userData"));

  const hasPCDRole = userDataPC?.data?.roles?.some(
    (r) => r.roleId === "SALES-PCD",
  );

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            {/* HEADER */}
            <Row className="mb-4">
              <Row>
                <Col xs={12} md={8}>
                  <h2 className="mainTitle">
                    ERF Detail - {formInputs.patientName}
                    <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage ms-2">
                      {documentNumber || equipmentNr}
                    </span>
                  </h2>
                  <p className="subText">Equipment Rental Details</p>
                </Col>
              </Row>
              {/* <Row>
                <Col
                  xs={6}
                  md={{ span: 2, offset: 10 }}
                  lg={{ span: 2, offset: 10 }}
                  className="text-left"
                >
                  {edit ? (
                    <>
                      <button className="btn btn-primary" onClick={handleEdit}>
                        <i className="bi bi-pencil-square px-2"></i> Edit
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className="btn btn-primary"
                        // onClick={handleUpdate}
                        onClick={() => showApproveModal("Update")}
                        disabled={!isFormEnabled}
                      >
                        <i className="bi bi-arrow-repeat px-2"></i> Update
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={handleCancelEdit}
                      >
                        <i className="bi bi-x-circle px-2"></i> Cancel
                      </button>
                    </>
                  )}
                </Col>
              </Row> */}
            </Row>
            <hr />

            <Loader isLoading={loading} className={"text-center"} />

            {!loading && (
              <>
                {/* ORDER DETAILS ACCORDION */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${
                              isCardVisible
                                ? "bi-chevron-down"
                                : "bi-chevron-right"
                            }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col xs={1} className="text-center logoBtn">
                          <span className="iconLogo">OD</span>
                        </Col>
                        <Col xs={10}>
                          <span className="headerTitle">Order Details</span>
                          <span className="subHeaderTitle">
                            Basic information
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body pb-4">
                        {/* Order & Patient Fields */}
                        <Row className="pt-2">
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <ComboboxField
                              label="ERF Type"
                              data={erfTypeOptions}
                              name="erfType"
                              textField="name"
                              setValue={formInputs?.erfType}
                              getvalue={setDropdownData}
                              // disabled={disabled}
                              disabled={true} // always disabled for editing ERF type
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <ComboboxField
                              label="Privilege Case"
                              data={privilegeOptions}
                              name="privilegeCase"
                              textField="name"
                              setValue={formInputs.privilegeCase}
                              getvalue={setDropdownData}
                              disabled={true} // always disabled for editing Privilage type
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <InputField
                              className="inputBox"
                              type="date"
                              label="Order Date"
                              name="orderDate"
                              value={formInputs.orderDate}
                              onChange={handleInputChange}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <ComboboxField
                              label="Sale Point"
                              data={SALE_POINT_OPTIONS}
                              name="salePoint"
                              textField="name"
                              setValue={formInputs.salePoint}
                              getvalue={setDropdownData}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <ComboboxField
                              label="Order Type"
                              data={ORDER_TYPE_OPTIONS}
                              name="orderType"
                              textField="name"
                              setValue={formInputs.orderType}
                              getvalue={setDropdownData}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <ComboboxField
                              label="Source of Call"
                              data={SOURCE_OF_CALL_OPTIONS}
                              name="sourceOfCall"
                              textField="name"
                              setValue={formInputs.sourceOfCall}
                              getvalue={setDropdownData}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <InputField
                              className="inputBox"
                              label="Cost Center"
                              name="costCenter"
                              value={formInputs.costCenter}
                              onChange={handleInputChange}
                              disabled={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <InputField
                              className="inputBox"
                              label="Billing Name"
                              name="billingName"
                              value={formInputs?.billingName}
                              onChange={handleInputChange}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>

                          {/*    <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <span className="fw-medium text-black">
                              Update Remarks / Version  
                            </span>
                            <div>
                              <span
                                style={{ marginLeft: "12px" }}
                                onClick={() =>
                                  remarkItemShowModal(formInputs.updateRemarks)
                                }
                              >
                                <i className="bi bi-calendar2-week iconTable"></i>
                              </span>
                              <span className="suppliersIcon">
                                {formInputs?.updateRemarks?.length > 0
                                  ? `${formInputs.updateRemarks.length}/${formInputs?.version}`
                                  : `0/${formInputs?.version}`}
                              </span>
                            </div>
                          </Col> */}
                          {/* {formInputs?.erfType === "Rent" && (
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <label
                                htmlFor="extensionCheckbox"
                                className="fw-medium mb-0"
                                style={{ cursor: "pointer" }}
                              >
                                Extension
                              </label>
                              <input
                                id="extensionCheckbox"
                                label=""
                                type="checkbox"
                                name="extension"
                                checked={formInputs?.extension}
                                onChange={handleCheckBoxInputChange}
                              />
                            </Col>
                          )} */}
                          {APPROVAL_REQUIRED_CASES.includes(
                            formInputs.privilegeCase,
                          ) && (
                            <>
                              <Col
                                xs={12}
                                md={12}
                                lg={6}
                                className="commTopButtonRightLeftPadding mb-3"
                              >
                                <label
                                  className="fw-bold mb-2"
                                  style={{ fontSize: "14px" }}
                                >
                                  Approval Level
                                </label>
                                <div className="d-flex gap-4 ps-3 p-3">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="approvalLevel"
                                      id="levelOne"
                                      checked={formInputs.approvalLevel === "1"}
                                      onChange={() =>
                                        setFormInputs((prev) => ({
                                          ...prev,
                                          approvalLevel: "1",
                                          approvers: [],
                                        }))
                                      }
                                    />
                                    <label
                                      className="form-check-label pointer"
                                      htmlFor="levelOne"
                                    >
                                      1 Level Approval
                                    </label>
                                  </div>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="approvalLevel"
                                      id="levelTwo"
                                      checked={formInputs.approvalLevel === "2"}
                                      onChange={() =>
                                        setFormInputs((prev) => ({
                                          ...prev,
                                          approvalLevel: "2",
                                          approvers: [],
                                        }))
                                      }
                                      disabled={true}
                                    />
                                    <label
                                      className="form-check-label pointer"
                                      htmlFor="levelTwo"
                                    >
                                      2 Level Approval
                                    </label>
                                  </div>
                                </div>
                              </Col>

                              <Row>
                                {/* Level 1 Dropdown - Appears for both Level 1 and Level 2 selection */}
                                {(formInputs.approvalLevel === "1" ||
                                  formInputs.approvalLevel === "2") && (
                                  <Col
                                    xs={12}
                                    md={6}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding mb-3"
                                  >
                                    <ComboboxField
                                      label="Select Level 1 Approver"
                                      data={APPROVED_BY_OPTIONS_LEVEL_ONE}
                                      name="approver_1"
                                      textField="name"
                                      required="true"
                                      getvalue={(data) =>
                                        handleApproverSelection(0, data)
                                      }
                                      setValue={
                                        formInputs.approverList[0]?.name
                                      }
                                      // disabled={!isFormEnabled}
                                      disabled={true}
                                    />
                                  </Col>
                                )}

                                {/* Level 2 Dropdown - Appears ONLY if Level 2 is selected */}
                                {formInputs.approvalLevel === "2" && (
                                  <Col
                                    xs={12}
                                    md={6}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding mb-3"
                                  >
                                    <ComboboxField
                                      label="Select Level 2 Approver"
                                      data={APPROVED_BY_OPTIONS_LEVEL_TWO}
                                      name="approver_2"
                                      required="true"
                                      textField="name"
                                      getvalue={(data) =>
                                        handleApproverSelection(1, data)
                                      }
                                      setValue={
                                        formInputs.approverList[1]?.name
                                      }
                                      // disabled={!isFormEnabled}
                                      disabled={true}
                                    />
                                  </Col>
                                )}
                              </Row>
                            </>
                          )}

                          {/* <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <ComboboxField
                              label="Approved By"
                              data={APPROVED_BY_OPTIONS}
                              name="approvedBy"
                              textField="name"
                              setValue={formInputs.approvedBy}
                              getvalue={setDropdownData}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col> */}
                        </Row>
                        {/* ERF For Type Selection */}
                        <Row className="pt-2 mb-4 bg-light p-3 rounded">
                          <Col xs={12}>
                            <h6 className="text-primary mb-3">
                              ERF Type Selection
                            </h6>
                            <div className="d-flex gap-4">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="erfForType"
                                  id="erfForPatient"
                                  value="Patient"
                                  checked={erfForType === "Patient"}
                                  onChange={(e) => {
                                    setErfForType(e.target.value);
                                    setSelectedHospital(null);
                                  }}
                                  disabled={true}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="erfForPatient"
                                >
                                  <strong>Patient</strong>
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="erfForType"
                                  id="erfForHospital"
                                  value="Hospital"
                                  checked={erfForType === "Hospital"}
                                  onChange={(e) => {
                                    setErfForType(e.target.value);
                                    // Clear patient data
                                    setFormInputs((prev) => ({
                                      ...prev,
                                      patientName: "",
                                      contactNumber: "",
                                      age: "",
                                      weight: "",
                                      aadharNo: "",
                                    }));
                                  }}
                                  disabled={true}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="erfForHospital"
                                >
                                  <strong>Hospital</strong>
                                </label>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <hr className="my-3 text-muted" />

                        {/* Doctor Info */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* HOSPITAL INFORMATION SECTION - Only show for B2B */}
                {erfForType === "Hospital" && (
                  <div className="accordion mb-4" id="accordionHospital">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col xs={1} className="text-left arrowBtn">
                            <i className="bi bi-chevron-down"></i>
                          </Col>
                          <Col xs={1} className="text-center logoBtn">
                            <span className="iconLogo">HI</span>
                          </Col>
                          <Col xs={10}>
                            <span className="headerTitle">
                              Hospital Information
                            </span>
                          </Col>
                        </Row>
                      </h2>

                      <div className="accordion-collapse collapse show visible">
                        <div className="accordion-body pb-4">
                          {/* Hospital Selection */}
                          <Row className="mb-4">
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Select Hospital For ERF"
                                data={erfHospitalList}
                                name="selectedHospitalId"
                                textField="name"
                                // setValue={selectedHospital?.userId || ""}
                                setValue={
                                  selectedHospital
                                    ? selectedHospital.hospitalName ||
                                      selectedHospital.organisationName
                                    : ""
                                } // Show the NAME, not userId
                                getvalue={setDropdownData}
                                // disabled={!isFormEnabled}
                                isLoading={isErfLoadingHospitals}
                                placeholder="Select Hospital"
                                required={true}
                                disabled={true}
                              />
                            </Col>
                          </Row>

                          {/* Hospital Details Display (Read-Only) */}
                          <>
                            <Row>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding mb-3"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Hospital Name"
                                  name="hospitalName"
                                  value={formInputs.hospitalName || ""}
                                  onChange={handleInputChange}
                                  disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding mb-3"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Association Number"
                                  name="AssociateNumber"
                                  value={formInputs.AssociateNumber || ""}
                                  onChange={handleInputChange}
                                  disabled={true}
                                />
                              </Col>
                              {!hasPCDRole && (
                                <>
                                  <Col
                                    xs={12}
                                    md={6}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding mb-3"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Contact Number"
                                      name="mobileNr"
                                      value={formInputs.mobileNr || ""}
                                      onChange={handleInputChange}
                                      disabled={true}
                                    />
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={6}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding mb-3"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Email"
                                      name="email"
                                      value={formInputs.email || ""}
                                      onChange={handleInputChange}
                                      disabled={true}
                                    />
                                  </Col>
                                </>
                              )}
                            </Row>

                            <Row>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding mb-3"
                              >
                                <InputField
                                  className="inputBox"
                                  label="GST No"
                                  name="gstNo"
                                  value={formInputs.gstNo || ""}
                                  onChange={handleInputChange}
                                  // disabled={disabled || !isFormEnabled}
                                  disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding mb-3"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Address Line 1"
                                  name="address"
                                  value={formInputs.address || ""}
                                  onChange={handleInputChange}
                                  disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding mb-3"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Address Line 2"
                                  name="address2"
                                  value={formInputs.address2 || ""}
                                  onChange={handleInputChange}
                                  disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding mb-3"
                              >
                                <InputField
                                  className="inputBox"
                                  label="City"
                                  name="city"
                                  value={formInputs.city || ""}
                                  onChange={handleInputChange}
                                  disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={6}
                                className="commTopButtonRightLeftPadding mb-3"
                              >
                                <TextAreaField
                                  className="inputBox"
                                  label="Billing Address"
                                  name="billingAddress"
                                  value={formInputs.billingAddress || ""}
                                  onChange={handleInputChange}
                                  disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding mb-3"
                              >
                                <InputField
                                  className="inputBox"
                                  label="State"
                                  name="billingState"
                                  value={formInputs.billingState || ""}
                                  onChange={handleInputChange}
                                  disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding mb-3"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Postal Code"
                                  name="billingPinCode"
                                  value={formInputs.billingPinCode || ""}
                                  onChange={handleInputChange}
                                  disabled={true}
                                />
                              </Col>
                            </Row>
                          </>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible3
                                ? "bi-chevron-down"
                                : "bi-chevron-right"
                            }`}
                            onClick={toggleCardVisibility3}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">PI</span>
                        </Col>
                        <Col xs={10}>
                          <span className="headerTitle">
                            Patient Information
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible3 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body pb-4">
                        <h6 className="text-primary mb-3 ps-2 mt-2">
                          Doctor Information
                        </h6>
                        <Row>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <ComboboxField
                              label="Dr. Type"
                              data={DOCTOR_TYPE_OPTIONS}
                              name="drType"
                              textField="name"
                              setValue={formInputs.drType}
                              getvalue={setDropdownData}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>

                          {/* Show Hospital Dropdown when drType is "Hospital" or "Listed" */}
                          {(formInputs.drType === "Hospital" ||
                            formInputs.drType === "Listed") && (
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding mb-3"
                            >
                              <ComboboxField
                                label="Hospital"
                                data={hospitalList}
                                name="hospital"
                                textField="name"
                                setValue={formInputs.hospital}
                                getvalue={setDropdownData}
                                disabled={disabled || !isFormEnabled}
                                isLoading={isLoadingHospitals}
                                placeholder="Select Hospital"
                              />
                            </Col>
                          )}
                          {/* Doctor Name Field - Dynamic based on Dr. Type */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            {formInputs.drType === "Hospital" ? (
                              // Hospital → Dropdown with doctors from selected hospital
                              <ComboboxField
                                label="Doctor Name"
                                data={doctorsList}
                                name="doctorName"
                                textField="name"
                                setValue={formInputs.doctorName}
                                getvalue={setDropdownData}
                                disabled={
                                  !formInputs.hospital ||
                                  !isFormEnabled ||
                                  disabled
                                }
                                isLoading={isLoadingDoctors}
                                placeholder={
                                  !formInputs.hospital
                                    ? "Select hospital first"
                                    : "Select Doctor"
                                }
                              />
                            ) : formInputs.drType === "Doctor" ? (
                              // Doctor → Dropdown with all doctors
                              <ComboboxField
                                label="Doctor Name"
                                data={doctorsList}
                                name="doctorName"
                                textField="name"
                                setValue={formInputs.doctorName}
                                getvalue={setDropdownData}
                                disabled={!isFormEnabled || disabled}
                                isLoading={isLoadingDoctors}
                                placeholder="Select Doctor"
                              />
                            ) : formInputs.drType === "Listed" ? (
                              // Listed → Dropdown with doctors from selected hospital (old logic)
                              <ComboboxField
                                label="Doctor Name"
                                data={doctorsList}
                                name="doctorName"
                                textField="name"
                                setValue={formInputs.doctorName}
                                getvalue={setDropdownData}
                                disabled={
                                  !formInputs.hospital ||
                                  !isFormEnabled ||
                                  disabled
                                }
                                isLoading={isLoadingDoctors}
                                placeholder={
                                  !formInputs.hospital
                                    ? "Select hospital first"
                                    : "Select Doctor"
                                }
                              />
                            ) : (
                              // Non-Listed, Not Given → Manual text input
                              <InputField
                                className="inputBox"
                                label="Doctor Name"
                                name="doctorName"
                                value={formInputs.doctorName}
                                onChange={handleInputChange}
                                disabled={
                                  formInputs.drType === "Not Given" ||
                                  !isFormEnabled ||
                                  disabled
                                }
                              />
                            )}
                          </Col>

                          {/* Dr. Code - Auto-filled for Hospital/Doctor/Listed, Manual for Non-Listed */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <InputField
                              className="inputBox"
                              label="Dr. Code"
                              name="drCode"
                              value={formInputs.drCode}
                              onChange={handleInputChange}
                              disabled={
                                formInputs.drType === "Hospital" ||
                                formInputs.drType === "Doctor" ||
                                formInputs.drType === "Listed" ||
                                formInputs.drType === "Not Given" ||
                                !isFormEnabled ||
                                disabled
                              }
                            />
                          </Col>
                        </Row>
                        {/* ERF Autocomplete Search */}
                        <Row className="mb-4">
                          <Col xs={12}>
                            <div className="p-3 bg-light rounded border">
                              <h6 className="text-primary mb-3">
                                Quick Fill from previous ERF
                              </h6>

                              <ERFAutocompleteSearch
                                onERFSelect={handleERFSelection}
                                disabled={!isFormEnabled}
                                placeholder="Type patient name or ERF number (min. 2 characters)..."
                              />

                              {/* Preview of Loaded ERF */}
                              {isERFLoaded && selectedERF && (
                                <div
                                  className="alert alert-soft-primary d-flex align-items-center mt-3 border-0 shadow-sm"
                                  role="alert"
                                >
                                  <div className="fs-4 me-3 text-primary">
                                    <i className="bi bi-check-circle-fill"></i>
                                  </div>
                                  <div className="flex-grow-1">
                                    <h6 className="alert-heading fw-bold mb-1">
                                      ERF Loaded Successfully
                                    </h6>
                                    <p className="mb-0 small text-muted">
                                      <strong>ID:</strong>{" "}
                                      {selectedERF.documentNumber} &bull;
                                      <strong> Patient:</strong>{" "}
                                      {selectedERF.patientName} &bull;
                                      <strong> Contact:</strong>{" "}
                                      {selectedERF.contactNumber}
                                    </p>
                                  </div>
                                  <button
                                    className="btn btn-sm btn-outline-danger ms-3"
                                    onClick={() => {
                                      setSelectedERF(null);
                                      setIsERFLoaded(false);
                                    }}
                                  >
                                    <i className="bi bi-x-lg me-1"></i> Clear
                                  </button>
                                </div>
                              )}
                            </div>
                          </Col>
                        </Row>

                        <hr className="my-3 text-muted" />

                        {/* Patient Info */}

                        <h6
                          className="text-primary mb-3 ps-2"
                          style={{ fontSize: "14px", fontWeight: "600" }}
                        >
                          Patient Information
                        </h6>
                        <Row>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <InputField
                              className="inputBox"
                              label="Patient Name"
                              name="patientName"
                              value={formInputs.patientName}
                              onChange={handleInputChange}
                              required
                              error={validation.patientName}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <InputField
                              className="inputBox"
                              label="Contact No"
                              name="contactNumber"
                              value={formInputs.contactNumber}
                              onChange={handleInputChange}
                              required
                              type="number"
                              error={validation.contactNumber}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>
                          <Col
                            xs={6}
                            md={3}
                            lg={2}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <InputField
                              className="inputBox"
                              label="Age"
                              name="age"
                              value={formInputs.age}
                              onChange={handleInputChange}
                              type="number"
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>
                          <Col
                            xs={6}
                            md={3}
                            lg={2}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <InputField
                              className="inputBox"
                              label="Weight (Kg)"
                              name="weight"
                              value={formInputs.weight}
                              onChange={handleInputChange}
                              type="number"
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={2}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <InputField
                              className="inputBox"
                              label="GST No"
                              name="gstNo"
                              value={formInputs.gstNo}
                              onChange={handleInputChange}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <InputField
                              className="inputBox"
                              label="PAN No"
                              name="panNo"
                              value={formInputs.panNo}
                              onChange={handleInputChange}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <InputField
                              className="inputBox"
                              label="Aadhar No"
                              name="aadharNo"
                              value={formInputs.aadharNo}
                              onChange={handleInputChange}
                              required
                              error={validation.aadharNo}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={2}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <ComboboxField
                              label="Is Diabetic?"
                              data={IS_DIABETIC_OPTIONS}
                              name="isDiabetic"
                              textField="name"
                              setValue={formInputs.isDiabetic}
                              getvalue={setDropdownData}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={12}
                            lg={12}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Patient Challenges"
                              name="patientChallenges"
                              value={formInputs.patientChallenges}
                              onChange={handleInputChange}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>
                        </Row>

                        <hr className="my-3 text-muted" />

                        {/* Caregiver Info */}
                        <h6
                          className="text-primary mb-3 ps-2"
                          style={{ fontSize: "14px", fontWeight: "600" }}
                        >
                          Caregiver Information
                        </h6>
                        <Row>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <InputField
                              className="inputBox"
                              label="Caregiver Name"
                              name="caregiverName"
                              value={formInputs.caregiverName}
                              onChange={handleInputChange}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <InputField
                              className="inputBox"
                              label="Relationship"
                              name="caregiverRelation"
                              value={formInputs.caregiverRelation}
                              onChange={handleInputChange}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <ComboboxField
                              label="ID Proof Type"
                              data={ID_PROOF_OPTIONS}
                              name="idProof"
                              textField="name"
                              setValue={formInputs.idProof}
                              getvalue={setDropdownData}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>
                          {formInputs.idProof &&
                            formInputs.idProof !== "Select" && (
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding mb-3"
                              >
                                <InputField
                                  className="inputBox"
                                  label={`${formInputs.idProof} Number`}
                                  name="idProofNumber"
                                  placeholder={`Enter ${formInputs.idProof} number`}
                                  value={formInputs.idProofNumber}
                                  onChange={handleInputChange}
                                  disabled={disabled || !isFormEnabled}
                                  required
                                  error={validation.idProofNumber}
                                />
                              </Col>
                            )}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding mb-3"
                          >
                            <InputField
                              className="inputBox"
                              label="Email ID"
                              name="emailId"
                              value={formInputs.emailId}
                              onChange={handleInputChange}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>
                        </Row>

                        {/* Addresses */}
                        <Row className="mt-2">
                          <Col md={6} className="pe-md-4">
                            <h6
                              className="text-primary mb-3 ps-2"
                              style={{ fontSize: "14px", fontWeight: "600" }}
                            >
                              Billing Address
                            </h6>
                            <Row>
                              <Col
                                xs={12}
                                md={12}
                                className="commTopButtonRightLeftPadding mb-3"
                              >
                                <TextAreaField
                                  className="inputBox"
                                  label="Address"
                                  name="billingAddress"
                                  value={formInputs.billingAddress}
                                  onChange={handleInputChange}
                                  disabled={disabled || !isFormEnabled}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                className="commTopButtonRightLeftPadding mb-3"
                              >
                                <ComboboxField
                                  label="State"
                                  data={STATE_OPTIONS}
                                  name="billingState"
                                  textField="name"
                                  setValue={formInputs.billingState}
                                  getvalue={setDropdownData}
                                  disabled={disabled || !isFormEnabled}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                className="commTopButtonRightLeftPadding mb-3"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Pin Code"
                                  name="billingPinCode"
                                  value={formInputs.billingPinCode}
                                  onChange={handleInputChange}
                                  type="number"
                                  disabled={disabled || !isFormEnabled}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col md={6} className="ps-md-4 border-start-md">
                            <h6
                              className="text-primary mb-3 ps-2"
                              style={{ fontSize: "14px", fontWeight: "600" }}
                            >
                              Delivery Address
                            </h6>
                            <Row>
                              <Col
                                xs={12}
                                md={12}
                                className="commTopButtonRightLeftPadding mb-3"
                              >
                                <TextAreaField
                                  className="inputBox"
                                  label="Address"
                                  name="deliveryAddress"
                                  value={formInputs.deliveryAddress}
                                  onChange={handleInputChange}
                                  disabled={disabled || !isFormEnabled}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                className="commTopButtonRightLeftPadding mb-3"
                              >
                                <ComboboxField
                                  label="State"
                                  data={STATE_OPTIONS}
                                  name="deliveryState"
                                  textField="name"
                                  setValue={formInputs.deliveryState}
                                  getvalue={setDropdownData}
                                  disabled={disabled || !isFormEnabled}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                className="commTopButtonRightLeftPadding mb-3"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Pin Code"
                                  name="deliveryPinCode"
                                  value={formInputs.deliveryPinCode}
                                  onChange={handleInputChange}
                                  type="number"
                                  disabled={disabled || !isFormEnabled}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${
                              isCardVisible4
                                ? "bi-chevron-down"
                                : "bi-chevron-right"
                            }`}
                            onClick={toggleCardVisibility4}
                          ></i>
                        </Col>
                        <Col xs={1} className="text-center logoBtn">
                          <span className="iconLogo">PC</span>
                        </Col>
                        <Col xs={10}>
                          <span className="headerTitle">
                            Information to be filled by PC Dept.
                          </span>
                          <span className="subHeaderTitle">
                            Basic information
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible4 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body pb-4">
                        <Row className="pt-2">
                          {/* PC Call Status */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              className="inputBox"
                              label="PC Call Status"
                              name="pcCallStatus"
                              code="pcCallStatusCode"
                              description="pcCallStatusDesc"
                              // data={pcCallStatusOptions}
                              index="pcCallStatus"
                              iconClassName="dropdownIcon"
                              // getvalue={handleComboboxChange} //  Use wrapper function
                              setValue={formInputs.pcCallStatus}
                              disabled={true}
                            />
                          </Col>

                          {/* Days */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Days"
                              name="days"
                              type="number"
                              value={formInputs.days}
                              onChange={handleInputChange}
                              disabled={true}
                            />
                          </Col>

                          {/* Previous Days */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Previous Days"
                              name="previousDays"
                              value={formInputs.previousDays}
                              disabled
                            />
                          </Col>

                          {/* Starting Date */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Starting Date"
                              type="date"
                              name="startingDate"
                              value={formInputs.startingDate}
                              onChange={handleInputChange}
                              disabled={true}
                            />
                          </Col>

                          {/* Ending Date */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Ending Date"
                              type="date"
                              name="endingDate"
                              value={formInputs.endingDate}
                              onChange={handleInputChange}
                              disabled={true}
                            />
                          </Col>

                          {/* Early Closure Date */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Early Closure Date"
                              type="date"
                              name="earlyClosureDate"
                              value={formInputs.earlyClosureDate}
                              onChange={handleInputChange}
                              disabled={true}
                            />
                          </Col>

                          {/* Remarks */}
                          <Col
                            xs={12}
                            md={12}
                            lg={6}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Remarks"
                              name="pbRemarks"
                              value={formInputs.pbRemarks}
                              onChange={handleInputChange}
                              disabled={true}
                            />
                          </Col>

                          {/* Payment Location */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              className="inputBox"
                              label="Payment Location"
                              name="paymentLocation"
                              value={formInputs.paymentLocation}
                              onChange={handleInputChange}
                              // options={paymentLocationList}
                              disabled={true}
                            />
                          </Col>

                          {/* RE No */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="RE No"
                              name="reNo"
                              value={formInputs.reNo}
                              disabled
                            />
                          </Col>

                          {/* Visit Charges */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            {/* <InputField
                  className="inputBox"
                  label="Visit Charges"
                  name="visitCharges"
                  type="number"
                  value={formInputs.visitCharges}
                  onChange={handleInputChange}
                  disabled={isPCDisabled || disableDaysAndCharges}
                /> */}
                            <InputField
                              className="inputBox"
                              label="Visit Charges"
                              name="visitCharges"
                              type="number"
                              value={formInputs.visitCharges}
                              onChange={handleInputChange}
                              disabled={true}
                            />
                          </Col>

                          {/* Total Amount */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            {/* <InputField
                      className="inputBox"
                        label="Total Amount"
                        name="totalAmount"
                        value={formInputs.totalAmount}
                        disabled
                      /> */}
                            <InputField
                              className="inputBox"
                              label="Total Amount"
                              name="totalAmount"
                              value={formInputs.totalAmount}
                              disabled
                            />
                          </Col>

                          {/* Payment Received Date */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Payment Rec. Date"
                              type="date"
                              name="paymentReceivedDate"
                              value={formInputs.paymentReceivedDate}
                              onChange={handleInputChange}
                              disabled={true}
                            />
                          </Col>

                          {/* Refund Days */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Refund Days"
                              name="refundDays"
                              type="number"
                              value={formInputs.refundDays}
                              onChange={handleInputChange}
                              disabled={true}
                            />
                          </Col>

                          {/* Refund Amount */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Refund Amount"
                              name="refundAmount"
                              type="number"
                              value={formInputs.refundAmount}
                              onChange={handleInputChange}
                              disabled={true}
                            />
                          </Col>

                          {/* Refund Remarks */}
                          <Col
                            xs={12}
                            md={12}
                            lg={6}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Refund Remarks"
                              name="refundRemarks"
                              value={formInputs.refundRemarks}
                              onChange={handleInputChange}
                              disabled={true}
                            />
                          </Col>

                          {/* Refund Type */}
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              className="inputBox"
                              label="Refund Type"
                              name="refundType"
                              // data={refundStatuses}
                              value={formInputs.refundType}
                              onChange={handleInputChange}
                              disabled={true}
                            />
                          </Col>
                          {/* <Row className="mb-3">
                                            <Col
                                              xs={12}
                                              md={2}
                                              className="d-flex align-items-end"
                                            >
                                              <button
                                                className="btn btn-primary w-100 ms-4"
                                                // onClick={handleToDateSubmit}
                                              >
                                                Submit
                                              </button>
                                            </Col>
                    
                                          </Row> */}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* PRICE SCHEDULE (PRODUCT DETAILS) ACCORDION */}
                {formInputs.erfType !== "Nursing Service" && (
                  <div className="accordion mb-4" id="accordionProduct">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col xs={1} className="text-left arrowBtn">
                            <i
                              className={`bi ${
                                isCardVisible2
                                  ? "bi-chevron-down"
                                  : "bi-chevron-right"
                              }`}
                              onClick={toggleCardVisibility2}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">P</span>
                          </Col>
                          <Col xs={12} md={8} lg={8}>
                            <span className="headerTitle">Product Details</span>
                          </Col>
                        </Row>
                      </h2>
                      <div
                        className={`accordion-collapse collapse show ${
                          isCardVisible2 ? "visible" : ""
                        }`}
                      >
                        <div className="accordion-body">
                          {/* RENT TABLE */}
                          {(formInputs.erfType === "Rent" ||
                            formInputs.erfType === "Sale & Rent") && (
                            <div className="mb-4">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <Col
                                  xs={12}
                                  md={8}
                                  lg={10}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <h6 className="fw-bold ps-2 text-primary">
                                    Rent Products
                                  </h6>
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={2}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <button
                                    className="btnTable"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      addProductDetails("Rent");
                                    }}
                                    disabled={disabled || !isFormEnabled}
                                  >
                                    <i className="bi bi-plus-lg"></i> Add Rent
                                    Item
                                  </button>
                                </Col>
                              </div>
                              <DataTable
                                columns={getColumns("Rent")}
                                data={getDataWithTotal(rentItems)}
                                pagination
                                paginationRowsPerPageOptions={
                                  Constants.ROW_PER_PAGE
                                }
                                noDataComponent={
                                  <div className="p-2 text-center text-muted">
                                    No Rent items.
                                  </div>
                                }
                                conditionalRowStyles={customStyles.rows}
                              />
                              <hr />
                            </div>
                          )}

                          {/* SALE / SERVICE TABLE */}
                          {(formInputs.erfType === "Sale" ||
                            formInputs.erfType === "Sale & Rent" ||
                            formInputs.erfType === "Service") && (
                            <div className="mb-4">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <Col
                                  xs={12}
                                  md={8}
                                  lg={10}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <h6 className="fw-bold ps-2 text-primary">
                                    {formInputs.erfType === "Service"
                                      ? "Service Items"
                                      : "Sale Products"}
                                  </h6>
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={2}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <button
                                    className="btnTable"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      addProductDetails(
                                        formInputs.erfType === "Sale & Rent"
                                          ? "Sale"
                                          : formInputs.erfType,
                                      );
                                    }}
                                    disabled={disabled || !isFormEnabled}
                                  >
                                    <i className="bi bi-plus-lg"></i> Add{" "}
                                    {formInputs.erfType === "Service"
                                      ? "Service"
                                      : "Sale"}{" "}
                                    Item
                                  </button>
                                </Col>
                              </div>
                              <DataTable
                                columns={getColumns(
                                  formInputs.erfType === "Service"
                                    ? "Service"
                                    : "Sale",
                                )}
                                data={getDataWithTotal(saleItems)}
                                pagination
                                paginationRowsPerPageOptions={
                                  Constants.ROW_PER_PAGE
                                }
                                noDataComponent={
                                  <div className="p-2 text-center text-muted">
                                    No items.
                                  </div>
                                }
                                conditionalRowStyles={customStyles.rows}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* PAYMENT DETAILS */}
                <div className="accordion mb-4" id="accordionPayment">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row
                        className="accordion-button"
                        onClick={() => toggleVisibility("PAY")}
                      >
                        <Col xs={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${visible.PAY ? "bi-chevron-down" : "bi-chevron-right"}`}
                          ></i>
                        </Col>
                        <Col xs={11}>
                          <span className="headerTitle">Payment Details</span>
                        </Col>
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${visible.PAY ? "visible" : ""}`}
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col md={6} className="pe-md-4">
                            <h6 className="text-primary mb-3 mt-3 ps-2">
                              Payment Details
                            </h6>
                            <Row className="mb-3">
                              <Col
                                md={12}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Total Amount"
                                  value={totalPayable}
                                  disabled
                                />
                              </Col>
                              <Col
                                md={12}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Cartage*"
                                  name="cartage"
                                  onChange={handleInputChange}
                                  type="number"
                                  value={formInputs.cartage}
                                  disabled={
                                    disabled ||
                                    !isFormEnabled ||
                                    (
                                      PRIVILEGE_SETTINGS[
                                        formInputs.privilegeCase
                                      ] || DEFAULT_PRIVILEGE_SETTINGS
                                    ).disableCartage
                                  }
                                />
                              </Col>
                              <Col
                                md={12}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Installation Charges*"
                                  name="installationCharges"
                                  onChange={handleInputChange}
                                  value={formInputs.installationCharges}
                                  type="number"
                                  disabled={disabled || !isFormEnabled}
                                />
                              </Col>
                              <Col
                                md={12}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Net Amount"
                                  value={netAmount}
                                  disabled
                                />
                              </Col>
                              <Col
                                md={12}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Enter Received Amount"
                                  name="receivedAmount"
                                  onChange={handleInputChange}
                                  value={formInputs.receivedAmount}
                                  type="number"
                                  disabled={disabled || !isFormEnabled}
                                />
                              </Col>
                              <Col
                                md={12}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Balance Amount"
                                  value={balanceAmount}
                                  disabled
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col md={6} className="ps-md-4 border-start-md">
                            <h6 className="text-primary mb-3 mt-3 ps-2">
                              Received Amt. Breakup
                            </h6>
                            <Row className="mb-3">
                              <Col
                                md={12}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Payment Mode*"
                                  data={paymentModeDropdown}
                                  name="paymentMode"
                                  textField="name"
                                  setValue={formInputs.paymentMode}
                                  getvalue={setDropdownData}
                                  disabled={disabled || !isFormEnabled}
                                />
                              </Col>
                              <Col
                                md={12}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Cash"
                                  name="cashAmount"
                                  onChange={handleInputChange}
                                  value={formInputs.cashAmount}
                                  type="number"
                                  disabled={
                                    disabled ||
                                    !isFormEnabled ||
                                    (
                                      PAYMENT_MODE_RULES[
                                        formInputs.paymentMode
                                      ] || {}
                                    ).disableCash ||
                                    (
                                      PAYMENT_MODE_RULES[
                                        formInputs.paymentMode
                                      ] || {}
                                    ).disableAll
                                  }
                                />
                              </Col>
                              <Col
                                md={12}
                                className="commTopButtonRightLeftPadding"
                              >
                                <Row>
                                  <Col md={4}>
                                    <label className="mt-2">
                                      {/* Dynamic Label (Req 3) */}
                                      {formInputs.paymentMode === "Card&Cash"
                                        ? "Card"
                                        : formInputs.paymentMode ===
                                            "Cheque&Cash"
                                          ? "Cheque"
                                          : formInputs.paymentMode ===
                                              "Card&Cheque"
                                            ? "Cheque"
                                            : "Bal. Amt"}
                                    </label>
                                  </Col>
                                  <Col md={8}>
                                    <InputField
                                      className="inputBox"
                                      name="balanceAmtBreakup"
                                      value={formInputs.balanceAmtBreakup}
                                      disabled
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col
                                md={12}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Cheque No."
                                  name="chequeNo"
                                  onChange={handleInputChange}
                                  value={formInputs.chequeNo}
                                  disabled={
                                    disabled ||
                                    !isFormEnabled ||
                                    (
                                      PAYMENT_MODE_RULES[
                                        formInputs.paymentMode
                                      ] || {}
                                    ).disableCheque ||
                                    (
                                      PAYMENT_MODE_RULES[
                                        formInputs.paymentMode
                                      ] || {}
                                    ).disableAll
                                  }
                                />
                              </Col>
                              <Col
                                md={12}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Card Trans. No."
                                  name="cardTransNo"
                                  onChange={handleInputChange}
                                  value={formInputs.cardTransNo}
                                  disabled={
                                    disabled ||
                                    !isFormEnabled ||
                                    (
                                      PAYMENT_MODE_RULES[
                                        formInputs.paymentMode
                                      ] || {}
                                    ).disableCard ||
                                    (
                                      PAYMENT_MODE_RULES[
                                        formInputs.paymentMode
                                      ] || {}
                                    ).disableAll
                                  }
                                />
                              </Col>
                              <Col
                                md={12}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Bank Name"
                                  name="bankName"
                                  onChange={handleInputChange}
                                  value={formInputs.bankName}
                                  disabled={
                                    disabled ||
                                    !isFormEnabled ||
                                    (
                                      PAYMENT_MODE_RULES[
                                        formInputs.paymentMode
                                      ] || {}
                                    ).disableBank ||
                                    (
                                      PAYMENT_MODE_RULES[
                                        formInputs.paymentMode
                                      ] || {}
                                    ).disableAll
                                  }
                                />
                              </Col>
                              <Col
                                md={12}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Receipt No."
                                  name="receiptNo"
                                  onChange={handleInputChange}
                                  value={formInputs.receiptNo}
                                  disabled={
                                    disabled ||
                                    !isFormEnabled ||
                                    (
                                      PAYMENT_MODE_RULES[
                                        formInputs.paymentMode
                                      ] || {}
                                    ).disableReceipt ||
                                    (
                                      PAYMENT_MODE_RULES[
                                        formInputs.paymentMode
                                      ] || {}
                                    ).disableAll
                                  }
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* SECURITY DETAILS */}
                {(formInputs.erfType === "Rent" ||
                  formInputs.erfType === "Sale & Rent") && (
                  <div className="accordion mb-4" id="accordionSecurity">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row
                          className="accordion-button"
                          onClick={() => toggleVisibility("SEC")}
                        >
                          <Col xs={1} className="text-left arrowBtn">
                            <i
                              className={`bi ${visible.SEC ? "bi-chevron-down" : "bi-chevron-right"}`}
                            ></i>
                          </Col>
                          <Col xs={11}>
                            <span className="headerTitle">
                              Security Details
                            </span>
                          </Col>
                        </Row>
                      </h2>
                      <div
                        className={`accordion-collapse collapse show ${visible.SEC ? "visible" : ""}`}
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col md={6} className="pe-md-4">
                              <Row className="mb-3">
                                <Col
                                  md={12}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Standard Security Amount"
                                    value={formInputs.standardSecurityAmt}
                                    disabled
                                  />
                                </Col>
                                <Col
                                  md={12}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Total Security Amount*"
                                    value={totals.security.toFixed(2)}
                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  md={12}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Enter Recd. Security Amount*"
                                    name="receivedSecurityAmt"
                                    onChange={handleInputChange}
                                    value={formInputs.receivedSecurityAmt}
                                    type="number"
                                    disabled={
                                      disabled ||
                                      !isFormEnabled ||
                                      (
                                        PRIVILEGE_SETTINGS[
                                          formInputs.privilegeCase
                                        ] || DEFAULT_PRIVILEGE_SETTINGS
                                      ).disableSecurityDetails
                                    }
                                  />
                                </Col>
                                <Col
                                  md={12}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Bal. Security Amount"
                                    value={balanceSecurityAmt}
                                    disabled
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col md={6} className="ps-md-4 border-start-md">
                              <Row className="mb-3">
                                <Col
                                  md={12}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Enter Pincode*"
                                    name="securityPincode"
                                    value={formInputs.securityPincode}
                                    onChange={handleInputChange}
                                    disabled={disabled || !isFormEnabled}
                                  />
                                </Col>
                                <Col
                                  md={12}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Security Amt. Mode"
                                    data={(() => {
                                      // Filter options based on Privilege Case settings
                                      const settings =
                                        PRIVILEGE_SETTINGS[
                                          formInputs.privilegeCase
                                        ] || DEFAULT_PRIVILEGE_SETTINGS;
                                      if (settings.securityAmtModeOptions) {
                                        return paymentModeDropdown.filter(
                                          (opt) =>
                                            settings.securityAmtModeOptions.includes(
                                              opt.name,
                                            ),
                                        );
                                      }
                                      return paymentModeDropdown;
                                    })()}
                                    name="securityAmtMode"
                                    textField="name"
                                    setValue={formInputs.securityAmtMode}
                                    getvalue={setDropdownData}
                                    disabled={
                                      disabled ||
                                      !isFormEnabled ||
                                      (
                                        PRIVILEGE_SETTINGS[
                                          formInputs.privilegeCase
                                        ] || DEFAULT_PRIVILEGE_SETTINGS
                                      ).disableSecurityDetails ||
                                      !formInputs.securityPincode
                                    }
                                  />
                                </Col>
                                <Col
                                  md={12}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Cash Amt Received"
                                    name="securityCashAmt"
                                    onChange={handleInputChange}
                                    value={formInputs.securityCashAmt}
                                    type="number"
                                    disabled={
                                      disabled ||
                                      !isFormEnabled ||
                                      !formInputs.securityPincode ||
                                      (
                                        PRIVILEGE_SETTINGS[
                                          formInputs.privilegeCase
                                        ] || DEFAULT_PRIVILEGE_SETTINGS
                                      ).disableSecurityDetails ||
                                      (
                                        PAYMENT_MODE_RULES[
                                          formInputs.securityAmtMode
                                        ] || {}
                                      ).disableCash ||
                                      (
                                        PAYMENT_MODE_RULES[
                                          formInputs.securityAmtMode
                                        ] || {}
                                      ).disableAll
                                    }
                                  />
                                </Col>

                                <Col
                                  md={12}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <Row>
                                    <Col md={4}>
                                      <label className="mt-2">
                                        {formInputs.securityAmtMode ===
                                        "Card&Cash"
                                          ? "Card"
                                          : formInputs.securityAmtMode ===
                                              "Cheque&Cash"
                                            ? "Cheque"
                                            : formInputs.securityAmtMode ===
                                                "Card&Cheque"
                                              ? "Cheque"
                                              : "Bal. Amt"}
                                      </label>
                                    </Col>
                                    <Col md={8}>
                                      <InputField
                                        className="inputBox"
                                        name="balanceSecurityBreakup"
                                        value={
                                          formInputs.balanceSecurityBreakup
                                        }
                                        disabled
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                                <Col
                                  md={12}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Cheque No."
                                    name="securityChequeNo"
                                    onChange={handleInputChange}
                                    value={formInputs.securityChequeNo}
                                    disabled={
                                      disabled ||
                                      !isFormEnabled ||
                                      !formInputs.securityPincode ||
                                      (
                                        PRIVILEGE_SETTINGS[
                                          formInputs.privilegeCase
                                        ] || DEFAULT_PRIVILEGE_SETTINGS
                                      ).disableSecurityDetails ||
                                      (
                                        PAYMENT_MODE_RULES[
                                          formInputs.securityAmtMode
                                        ] || {}
                                      ).disableCheque ||
                                      (
                                        PAYMENT_MODE_RULES[
                                          formInputs.securityAmtMode
                                        ] || {}
                                      ).disableAll
                                    }
                                  />
                                </Col>
                                <Col
                                  md={12}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Card Trans. No."
                                    name="securityCardTransNo"
                                    onChange={handleInputChange}
                                    value={formInputs.securityCardTransNo}
                                    disabled={
                                      disabled ||
                                      !isFormEnabled ||
                                      !formInputs.securityPincode ||
                                      (
                                        PRIVILEGE_SETTINGS[
                                          formInputs.privilegeCase
                                        ] || DEFAULT_PRIVILEGE_SETTINGS
                                      ).disableSecurityDetails ||
                                      (
                                        PAYMENT_MODE_RULES[
                                          formInputs.securityAmtMode
                                        ] || {}
                                      ).disableCard ||
                                      (
                                        PAYMENT_MODE_RULES[
                                          formInputs.securityAmtMode
                                        ] || {}
                                      ).disableAll
                                    }
                                  />
                                </Col>
                                <Col
                                  md={12}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Bank Name"
                                    name="securityBankName"
                                    onChange={handleInputChange}
                                    value={formInputs.securityBankName}
                                    disabled={
                                      disabled ||
                                      !isFormEnabled ||
                                      !formInputs.securityPincode ||
                                      (
                                        PRIVILEGE_SETTINGS[
                                          formInputs.privilegeCase
                                        ] || DEFAULT_PRIVILEGE_SETTINGS
                                      ).disableSecurityDetails ||
                                      (
                                        PAYMENT_MODE_RULES[
                                          formInputs.securityAmtMode
                                        ] || {}
                                      ).disableBank ||
                                      (
                                        PAYMENT_MODE_RULES[
                                          formInputs.securityAmtMode
                                        ] || {}
                                      ).disableAll
                                    }
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Security Mode Would be (Req 4) */}
                {(formInputs.erfType === "Rent" ||
                  formInputs.erfType === "Sale & Rent") && (
                  <div className="accordion mb-4" id="accordionSecurityMode">
                    <div className="accordion-item">
                      <div className="accordion-body p-4">
                        <h6 className="text-primary mb-3">
                          Security Mode Would be
                        </h6>
                        <Row className="align-items-center">
                          <Col md={3} className="commTopButtonRightLeftPadding">
                            <ComboboxField
                              label="Security Mode*"
                              data={paymentModeDropdown.filter(
                                (m) => m.name !== "NR",
                              )}
                              name="securityMode"
                              textField="name"
                              setValue={formInputs.securityMode}
                              getvalue={setDropdownData}
                              disabled={disabled || !isFormEnabled}
                            />
                          </Col>
                          <Col md={3} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="Cash Amt."
                              name="securityModeCash"
                              onChange={handleInputChange}
                              value={formInputs.securityModeCash}
                              type="number"
                              disabled={
                                disabled ||
                                !isFormEnabled ||
                                !["Card&Cash", "Cheque&Cash"].includes(
                                  formInputs.securityMode,
                                )
                              }
                            />
                          </Col>
                          <Col md={3} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="Bal. Sec. Amt."
                              value={(() => {
                                // Point 4, 25, 26, 27
                                if (
                                  ["Cash", "Euro", "Dollar"].includes(
                                    formInputs.securityMode,
                                  )
                                ) {
                                  return 0;
                                }
                                if (
                                  [
                                    "Card",
                                    "Cheque",
                                    "Online",
                                    "Paytm",
                                    "UPI",
                                    "Card&Cheque",
                                  ].includes(formInputs.securityMode)
                                ) {
                                  return balanceSecurityAmt;
                                }
                                // Else (Card&Cash, Cheque&Cash) - calculated via useEffect/State, displayed here
                                return formInputs.securityModeBal;
                              })()}
                              disabled
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                )}

                {/* Remarks (Moved out of accordion) */}
                <div className="mb-4 p-4 border rounded bg-white">
                  <TextAreaField
                    className="inputBox"
                    label="Remarks"
                    name="remarks"
                    value={formInputs.remarks}
                    onChange={handleInputChange}
                    disabled={disabled || !isFormEnabled}
                  />
                </div>

                <div className="accordion mb-4" id="accordionProduct">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${
                              isCardVisible5
                                ? "bi-chevron-down"
                                : "bi-chevron-right"
                            }`}
                            onClick={toggleCardVisibility5}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">RH</span>
                        </Col>
                        <Col xs={12} md={8} lg={8}>
                          <span className="headerTitle">Rent History</span>
                        </Col>
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible5 ? "visible" : ""
                      }`}
                    >
                      <div className="mb-4">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <Col
                            xs={12}
                            md={8}
                            lg={10}
                            className="commTopButtonRightLeftPadding"
                          >
                            <h6 className="fw-bold ps-2 text-primary">
                              Rent Products
                            </h6>
                          </Col>
                        </div>
                        <h5 className="mt-4 ms-4">Fresh Rental Details</h5>

                        <DataTable
                          columns={freshColumns}
                          data={rentItems}
                          pagination
                          progressPending={loading}
                          noDataComponent={
                            <div className="p-2 text-center">
                              No Fresh Rental Records
                            </div>
                          }
                        />

                        <h5 className="mt-4 ms-4">Extension Details</h5>

                        <DataTable
                          columns={extensionColumns}
                          data={extensionData}
                          pagination
                          progressPending={loading}
                          noDataComponent={
                            <div className="p-2 text-center">
                              No Extension Records
                            </div>
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {equipmentNr && (
                  <ERFPaymentHistoryView documentNumber={equipmentNr} />
                )}

                {/* FOOTER - Back Button */}
                <div className="pageFooter mb-4">
                  <Row className="justify-content-end">
                    <Col xs={6} md={2} className="pb-2">
                      <button
                        className="btnTable btn-success text-white w-100"
                        onClick={() =>
                          navigate(Constants.CUSTOMER_V5_MR_ERF_LIST)
                        }
                      >
                        Back
                      </button>
                    </Col>
                  </Row>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>

      <MaterialSelectionModalV5
        show={modalShow}
        onHide={hideModal}
        onSelectedData={handleGetSelectedMaterial}
      />

      <FailureModal
        show={getShowFailureModal}
        onHide={hideFailureModal}
        failuremodaldata={failureModalData}
        requiredfields={getErrorFields}
      />

      <UpdateRemarksModal
        show={updateModalShow}
        onHide={() => updateHideModal()}
        onvaluechange={handleValueChange}
      />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ErfExtenssionModal
        show={getModalShowExtenssionModal}
        onHide={hideModalExtenssionModal}
        data={getExtenssionData}
        onSave={handleSaveExtensions}
      />
    </main>
  );
};

export default ERFDetailSummary;
